export const MAIN_SETTLEMENT_TILE_INDEX = 524_800;

export enum FrameName {
	NOT_SET = "internal_empty", // internal

	GRASSLAND = "Grassland.png", // internal
	GRASSLAND1 = "Grassland_1.png",
	GRASSLAND2 = "Grassland_2.png",
	GRASSLAND3 = "Grassland_3.png",
	GRASSLAND4 = "Grassland_4.png",
	RUINED_FOREST = "Forest_Ruined.png", // toto sa dava, ked pila znici forest
	SETTLEMENT_EMPTY = "Settlement_Empty.png", // internal
	SETTLEMENT_EMPTY1 = "Settlement_Empty_1.png",
	SETTLEMENT_EMPTY2 = "Settlement_Empty_2.png",
	SETTLEMENT_EMPTY3 = "Settlement_Empty_3.png",
	SETTLEMENT_EMPTY4 = "Settlement_Empty_4.png",
	SETTLEMENT_EMPTY5 = "Settlement_Empty_5.png",
	SETTLEMENT_EMPTY6 = "Settlement_Empty_6.png",
	SETTLEMENT_EMPTY7 = "Settlement_Empty_7.png",
	SETTLEMENT_EMPTY8 = "Settlement_Empty_8.png",
	SETTLEMENT_EMPTY9 = "Settlement_Empty_9.png",
	SETTLEMENT_EMPTY10 = "Settlement_Empty_10.png",
	SETTLEMENT_EMPTY11 = "Settlement_Empty_11.png",
	SETTLEMENT_EMPTY12 = "Settlement_Empty_12.png",
	SETTLEMENT_EMPTY13 = "Settlement_Empty_13.png",
	SETTLEMENT_EMPTY14 = "Settlement_Empty_14.png",
	SETTLEMENT_EMPTY15 = "Settlement_Empty_15.png",
	SETTLEMENT_EMPTY16 = "Settlement_Empty_16.png",
	SETTLEMENT_EMPTY17 = "Settlement_Empty_17.png",
	SETTLEMENT_EMPTY18 = "Settlement_Empty_18.png",
	SETTLEMENT_EMPTY19 = "Settlement_Empty_19.png",
	SETTLEMENT_CASTLE = "Settlement_Castle.png", // internal
	SETTLEMENT_CASTLE_LEVEL1 = "Settlement_Castle_Lvl_1.png",
	SETTLEMENT_CASTLE_LEVEL2 = "Settlement_Castle_Lvl_2.png",
	SETTLEMENT_CASTLE_LEVEL3 = "Settlement_Castle_Lvl_3.png",
	SETTLEMENT_CASTLE_LEVEL4 = "Settlement_Castle_Lvl_4.png",
	SETTLEMENT_CASTLE_LEVEL5 = "Settlement_Castle_Lvl_5.png",
	SETTLEMENT_CASTLE_LEVEL6 = "Settlement_Castle_Lvl_6.png",
	SETTLEMENT_CASTLE_LEVEL7 = "Settlement_Castle_Lvl_7.png",
	SETTLEMENT_CASTLE_LEVEL8 = "Settlement_Castle_Lvl_8.png",
	SETTLEMENT_CASTLE_LEVEL9 = "Settlement_Castle_Lvl_9.png",
	SETTLEMENT_CASTLE_LEVEL10 = "Settlement_Castle_Lvl_10.png",
	FOREST = "Forest.png",
	DENSE_FOREST = "Forest_Dense.png",
	OLD_FOREST = "Forest_Old.png",
	HILLS = "Hills.png",
	MOUNTAINS = "Mountains.png",
	IRON_MOUNTAINS = "Iron_Mountains.png",
	SWAMP = "Swamp.png",
	WHEAT_FIELD = "Field_Wheat.png",
	HOPS_FIELD = "Field_Hops.png",
	CATTLE_RANGE = "Cattle_Range.png",
	CATTLE_RANGE_SPECIAL = "Cattle_Range_Not_Milka.png",
	SEAWEED_FIELD = "Seaweed.png",
	APPLE_GROVE = "Apple_Grove.png",
	GOLD_VEIN = "Vein_Gold.png",
	GEMS_VEIN = "Vein_Gem.png",
	COAL_DEPOSIT = "Coal_Deposit.png",
	SALT_DEPOSIT = "Salt_Deposit.png",

	RIVER_DELTA2 = "River_Delta_R.png",
	RIVER_DELTA4 = "River_Delta_D.png",
	RIVER_DELTA8 = "River_Delta_L.png",
	RIVER_DELTA1 = "River_Delta_U.png",
	SHALLOW_SEA = "Sea_Shallow.png",
	SHALLOW_SEA_ROCKS = "Sea_Rocks.png",
	SHALLOW_SEA_SMALL_FISH = "Fish_Small.png",
	SHALLOW_SEA_MEDIUM_FISH = "Fish_Medium_Shallow.png",
	SHALLOW_SEA_CORAL_REEF = "Coral_Reef_Shallow.png",
	DEEP_SEA = "Sea_Deep.png",
	DEEP_SEA_MEDIUM_FISH = "Fish_Medium_Deep.png",
	DEEP_SEA_BIG_FISH = "Fish_Big.png",
	DEEP_SEA_CORAL_REEF = "Coral_Reef_Deep.png",

	RIVER10 = "River_L_R.png",
	RIVER5 = "River_U_D.png",
	RIVER12 = "River_L_D.png",
	RIVER9 = "River_U_L.png",
	RIVER3 = "River_U_R.png",
	RIVER6 = "River_R_D.png",
	RIVER14 = "River_T_D.png",
	RIVER13 = "River_T_L.png",
	RIVER11 = "River_T_U.png",
	RIVER7 = "River_T_R.png",
	RIVER15 = "River_X.png",
	RIVER_SPRING2 = "River_Spring_R.png",
	RIVER_SPRING4 = "River_Spring_D.png",
	RIVER_SPRING8 = "River_Spring_L.png",
	RIVER_SPRING1 = "River_Spring_U.png",

	DEPLETED_FIELD = "Field_Depleted.png",
	ABANDONED_HUT = "Abandoned_Hut.png",
	BURNED_HOUSE = "Burned_House.png",
	OLD_BATTLEFIELD = "Old_Battlefield.png",
	GRASSLAND_CASTLE_RUINS = "Castle_Ruins_Grassland.png",
	HILLS_CASTLE_RUINS = "Castle_Ruins_Hills.png",
	MERCENARY_CAMP = "Mercenary_Camp.png",
	MERCHANT_SHIP = "Ship_Merchant.png",
	SHALLOW_SEA_SHIPWRECK = "Shipwreck_Shallow.png",
	SHALLOW_SEA_ROCKS_SHIPWRECK = "Shipwreck_Rocks.png",
	MERCENARY_SHIP = "Ship_Mercenary.png",
	TRAVELLING_MERCHANT = "Merchant_Travelling.png",
	WOLFS_DEN = "Den_Wolf.png",
	BEARS_DEN = "Den_Bear.png",
	FLOTSAM_JETSAM = "Flotsam_Jetsam.png",
	DAMAGED_MILL = "Damaged_Mill.png",
	COLLAPSED_MINE = "Collapsed_Mine.png",
	HORNETS_NEST = "Hornets_Nest.png",

	BANDIT_CAMP_SMALL = "Bandit_Camp_Small.png",
	BANDIT_CAMP_MEDIUM = "Bandit_Camp_Medium.png",
	BANDIT_CAMP_LARGE = "Bandit_Camp_Large.png",
	SHALLOW_SEA_SMALL_PIRATES = "Pirates_Small_Shallow.png",
	DEEP_SEA_SMALL_PIRATES = "Pirates_Small_Deep.png",
	SHALLOW_SEA_MEDIUM_PIRATES = "Pirates_Medium_Shallow.png",
	DEEP_SEA_MEDIUM_PIRATES = "Pirates_Medium_Deep.png",

	WARRIORS_ENEMY = "Brutes.png",
	BARRICADE_ENEMY = "Wicker_Pavise_Enemy.png",
	CAPTAIN_ENEMY = "Chieftan_Lv_1.png",
	CHIEFTAIN_ENEMY = "Chieftan_Lv_2.png",
	SHALLOW_SEA_RAIDERS_SKIFF = "Raiders_Skiff_Shallow.png",
	SHALLOW_SEA_RAIDERS_GALLEY = "Raiders_Boat_Shallow.png",
	SHALLOW_SEA_RAIDERS_FLAGSHIP = "Raiders_Flagship_Shallow.png",

	BEACH1 = "Beach_1.png",
	BEACH2 = "Beach_2.png",
	BEACH4 = "Beach_4.png",
	BEACH5 = "Beach_5.png",
	BEACH8 = "Beach_8.png",
	BEACH10 = "Beach_10.png",
	BEACH12 = "Beach_12.png",
	BEACH16 = "Beach_16.png",
	BEACH17 = "Beach_17.png",
	BEACH18 = "Beach_18.png",
	BEACH24 = "Beach_24.png",
	BEACH26 = "Beach_26.png",
	BEACH32 = "Beach_32.png",
	BEACH33 = "Beach_33.png",
	BEACH34 = "Beach_34.png",
	BEACH36 = "Beach_36.png",
	BEACH37 = "Beach_37.png",
	BEACH48 = "Beach_48.png",
	BEACH49 = "Beach_49.png",
	BEACH50 = "Beach_50.png",
	BEACH64 = "Beach_64.png",
	BEACH65 = "Beach_65.png",
	BEACH66 = "Beach_66.png",
	BEACH68 = "Beach_68.png",
	BEACH69 = "Beach_69.png",
	BEACH72 = "Beach_72.png",
	BEACH74 = "Beach_74.png",
	BEACH76 = "Beach_76.png",
	BEACH80 = "Beach_80.png",
	BEACH81 = "Beach_81.png",
	BEACH82 = "Beach_82.png",
	BEACH88 = "Beach_88.png",
	BEACH90 = "Beach_90.png",
	BEACH128 = "Beach_128.png",
	BEACH129 = "Beach_129.png",
	BEACH130 = "Beach_130.png",
	BEACH132 = "Beach_132.png",
	BEACH133 = "Beach_133.png",
	BEACH136 = "Beach_136.png",
	BEACH138 = "Beach_138.png",
	BEACH140 = "Beach_140.png",
	BEACH160 = "Beach_160.png",
	BEACH161 = "Beach_161.png",
	BEACH162 = "Beach_162.png",
	BEACH164 = "Beach_164.png",
	BEACH165 = "Beach_165.png",

	PALISADE9_LEVEL1 = "Settlement_Pallisade_U_L_Lvl_1.png",
	PALISADE1_LEVEL1 = "Settlement_Pallisade_U_Lvl_1.png",
	PALISADE3_LEVEL1 = "Settlement_Pallisade_U_R_Lvl_1.png",
	PALISADE8_LEVEL1 = "Settlement_Pallisade_L_Lvl_1.png",
	PALISADE2_LEVEL1 = "Settlement_Pallisade_R_Lvl_1.png",
	PALISADE12_LEVEL1 = "Settlement_Pallisade_L_D_Lvl_1.png",
	PALISADE4_LEVEL1 = "Settlement_Pallisade_D_Lvl_1.png",
	PALISADE6_LEVEL1 = "Settlement_Pallisade_R_D_Lvl_1.png",

	PALISADE9_LEVEL2 = "Settlement_Pallisade_U_L_Lvl_2.png",
	PALISADE1_LEVEL2 = "Settlement_Pallisade_U_Lvl_2.png",
	PALISADE3_LEVEL2 = "Settlement_Pallisade_U_R_Lvl_2.png",
	PALISADE8_LEVEL2 = "Settlement_Pallisade_L_Lvl_2.png",
	PALISADE2_LEVEL2 = "Settlement_Pallisade_R_Lvl_2.png",
	PALISADE12_LEVEL2 = "Settlement_Pallisade_L_D_Lvl_2.png",
	PALISADE4_LEVEL2 = "Settlement_Pallisade_D_Lvl_2.png",
	PALISADE6_LEVEL2 = "Settlement_Pallisade_R_D_Lvl_2.png",

	PALISADE9_LEVEL3 = "Settlement_Pallisade_U_L_Lvl_3.png",
	PALISADE1_LEVEL3 = "Settlement_Pallisade_U_Lvl_3.png",
	PALISADE3_LEVEL3 = "Settlement_Pallisade_U_R_Lvl_3.png",
	PALISADE8_LEVEL3 = "Settlement_Pallisade_L_Lvl_3.png",
	PALISADE2_LEVEL3 = "Settlement_Pallisade_R_Lvl_3.png",
	PALISADE12_LEVEL3 = "Settlement_Pallisade_L_D_Lvl_3.png",
	PALISADE4_LEVEL3 = "Settlement_Pallisade_D_Lvl_3.png",
	PALISADE6_LEVEL3 = "Settlement_Pallisade_R_D_Lvl_3.png",

	PALISADE9_LEVEL4 = "Settlement_Pallisade_U_L_Lvl_4.png",
	PALISADE1_LEVEL4 = "Settlement_Pallisade_U_Lvl_4.png",
	PALISADE3_LEVEL4 = "Settlement_Pallisade_U_R_Lvl_4.png",
	PALISADE8_LEVEL4 = "Settlement_Pallisade_L_Lvl_4.png",
	PALISADE2_LEVEL4 = "Settlement_Pallisade_R_Lvl_4.png",
	PALISADE12_LEVEL4 = "Settlement_Pallisade_L_D_Lvl_4.png",
	PALISADE4_LEVEL4 = "Settlement_Pallisade_D_Lvl_4.png",
	PALISADE6_LEVEL4 = "Settlement_Pallisade_R_D_Lvl_4.png",

	PALISADE9_LEVEL5 = "Settlement_Pallisade_U_L_Lvl_5.png",
	PALISADE1_LEVEL5 = "Settlement_Pallisade_U_Lvl_5.png",
	PALISADE3_LEVEL5 = "Settlement_Pallisade_U_R_Lvl_5.png",
	PALISADE8_LEVEL5 = "Settlement_Pallisade_L_Lvl_5.png",
	PALISADE2_LEVEL5 = "Settlement_Pallisade_R_Lvl_5.png",
	PALISADE12_LEVEL5 = "Settlement_Pallisade_L_D_Lvl_5.png",
	PALISADE4_LEVEL5 = "Settlement_Pallisade_D_Lvl_5.png",
	PALISADE6_LEVEL5 = "Settlement_Pallisade_R_D_Lvl_5.png",

	//roads
	DIRT_ROAD_TUTORIAL = "Road_Dirt_U_D_Tutorial.png",

	DIRT_ROAD = "Road_Dirt.png",
	DIRT_ROAD_1 = "Road_Dirt_L_D.png",
	DIRT_ROAD_2 = "Road_Dirt_L_R.png",
	DIRT_ROAD_3 = "Road_Dirt_R_D.png",
	DIRT_ROAD_4 = "Road_Dirt_T_D.png",
	DIRT_ROAD_5 = "Road_Dirt_T_L.png",
	DIRT_ROAD_6 = "Road_Dirt_T_R.png",
	DIRT_ROAD_7 = "Road_Dirt_T_U.png",
	DIRT_ROAD_8 = "Road_Dirt_U_D.png",
	DIRT_ROAD_9 = "Road_Dirt_U_L.png",
	DIRT_ROAD_10 = "Road_Dirt_U_R.png",
	DIRT_ROAD_11 = "Road_Dirt_X.png",

	GRAVEL_ROAD = "Road_Gravel.png",
	GRAVEL_ROAD_1 = "Road_Gravel_L_D.png",
	GRAVEL_ROAD_2 = "Road_Gravel_L_R.png",
	GRAVEL_ROAD_3 = "Road_Gravel_R_D.png",
	GRAVEL_ROAD_4 = "Road_Gravel_T_D.png",
	GRAVEL_ROAD_5 = "Road_Gravel_T_L.png",
	GRAVEL_ROAD_6 = "Road_Gravel_T_R.png",
	GRAVEL_ROAD_7 = "Road_Gravel_T_U.png",
	GRAVEL_ROAD_8 = "Road_Gravel_U_D.png",
	GRAVEL_ROAD_9 = "Road_Gravel_U_L.png",
	GRAVEL_ROAD_10 = "Road_Gravel_U_R.png",
	GRAVEL_ROAD_11 = "Road_Gravel_X.png",

	COBBLED_ROAD = "Road_Cobbled.png",
	COBBLED_ROAD_1 = "Road_Cobbled_L_D.png",
	COBBLED_ROAD_2 = "Road_Cobbled_L_R.png",
	COBBLED_ROAD_3 = "Road_Cobbled_R_D.png",
	COBBLED_ROAD_4 = "Road_Cobbled_T_D.png",
	COBBLED_ROAD_5 = "Road_Cobbled_T_L.png",
	COBBLED_ROAD_6 = "Road_Cobbled_T_R.png",
	COBBLED_ROAD_7 = "Road_Cobbled_T_U.png",
	COBBLED_ROAD_8 = "Road_Cobbled_U_D.png",
	COBBLED_ROAD_9 = "Road_Cobbled_U_L.png",
	COBBLED_ROAD_10 = "Road_Cobbled_U_R.png",
	COBBLED_ROAD_11 = "Road_Cobbled_X.png",

	FORD_CROSSING = "Ford_Crossing.png",
	FORD_CROSSING_1 = "Ford_Crossing_L_R.png",
	FORD_CROSSING_2 = "Ford_Crossing_U_D.png",

	WOODEN_BRIDGE = "Bridge_Wooden.png",
	WOODEN_BRIDGE_1 = "Bridge_Wooden_L_R.png",
	WOODEN_BRIDGE_2 = "Bridge_Wooden_U_D.png",

	STONE_BRIDGE = "Bridge_Stone.png",
	STONE_BRIDGE_1 = "Bridge_Stone_L_R.png",
	STONE_BRIDGE_2 = "Bridge_Stone_U_D.png",

	MOUNTAIN_ROAD = "Mountain_Road.png",
	HILLY_ROAD = "Hilly_Road.png",

	GATHERERS_HUT = "Gatherers_Hut.png",
	LUMBER_MILL = "Lumber_Mill.png",
	SMALL_HOUSES = "Small_Houses.png",
	WHEAT_FARM = "Wheat_Farm.png",
	GOLD_MINE = "Gold_Mine.png",
	PREMIUM_GOLD_MINE = "Gold_Mine_Premium.png",
	STONE_QUARRY = "Stone_Quarry.png",
	BAKERY = "Bakery.png",
	SHIPYARD = "Shipyard.png",
	SHALLOW_SEA_FISHING_BOAT = "Fishing_Boat_Shallow.png",
	DEEP_SEA_FISHING_BOAT = "Fishing_Boat_Deep.png",
	TOLL_HOUSE = "Toll_House.png",
	CLAY_PIT = "Clay_Pit.png",
	SMALL_STOCKPILE = "Small_Stockpile.png",
	IRON_MINE = "Iron_Mine.png",
	FURNACE = "Furnace.png",
	OXEN_STABLE = "Ox_Stable.png",
	BLACKSMITH = "Blacksmith.png",
	MARKET = "Market.png",
	SHALLOW_SEA_SMALL_FISH_TRAP = "Fish_Trap_Small.png",
	SHALLOW_SEA_MEDIUM_FISH_TRAP = "Fish_Trap_Medium.png",
	FOUNDRY = "Foundry.png",
	WAREHOUSE = "Warehouse.png",
	UNIVERSAL_WAREHOUSE = "Universal_Warehouse.png",
	TOOLMAKER = "Toolmaker.png",
	ARMORY = "Armory.png",
	BARRACKS = "Barracks.png",
	OUTPOST = "Outpost.png",
	HEALERS_HUT = "Healers_Hut.png",
	HUNTERS_LODGE = "Hunters_Lodge.png",
	TANNERY = "Tannery.png",
	TAILORS_WORKSHOP = "Tailors_Workshop.png",
	LARGE_STONE_QUARRY = "Large_Stone_Quarry.png",
	HILLS_SCOUT_TOWER = "Scout_Tower_Hills.png",
	MOUNTAINS_SCOUT_TOWER = "Scout_Tower_Mountain.png",
	LIVESTOCK_FARM = "Livestock_Farm.png",
	BREWERY = "Brewery.png",
	INN = "Inn.png",
	GEMS_MINE = "Gem_Mine.png",
	ADVANCED_IRON_MINE = "Advanced_Iron_Mine.png",
	MILL = "Mill.png",
	UNIVERSITY = "University.png",
	GUARD_TOWER = "Guard_Tower.png",
	MEDIUM_HOUSES = "Medium_Houses.png",
	PATISSERIE = "Patisserie.png",
	SHOEMAKER = "Shoemaker.png",
	INDUSTRIAL_LUMBER_MILL = "Industrial_Lumber_Mill.png",
	LARGE_CLAY_PIT = "Large_Clay_Pit.png",
	CARPENTRY_DISTRICT = "Carpentry_District.png",
	STONEMASONRY_DISTRICT = "Stonemasonry_District.png",
	TAX_OFFICE = "Tax_Office.png",
	LARGE_HOUSES = "Big_Houses.png",
	ARTISAN_SMITH = "Artisan_Smith.png",
	WATER_SAW_MILL = "Water_Saw_Mill.png",
	INDUSTRIAL_FOUNDRY = "Industrial_Foundry.png",
	ARENA = "Arena.png",
	MOUNTAIN_BELLOWS = "Mountain_Bellows.png",
	WATER_MILL = "Water_Mill.png",
	BRICKYARD = "Brickyard.png",
	FLETCHER = "Fletcher.png",
	ARCHERY_RANGE = "Archery_Range.png",
	SHALLOW_SEA_PEARL_HUNTER = "Pearl_Hunter_Shallow.png",
	DEEP_SEA_PEARL_HUNTER = "Pearl_Hunter_Deep.png",
	PORT = "Port.png",
	BATH_HOUSE = "Bath_House.png",
	GOLD_PROSPECTOR = "Gold_Prospector.png",
	APIARY = "Apiary.png",
	CANDLEMAKER = "Candlemaker.png",
	SADDLER = "Saddler.png",
	STABLES = "Stable.png",
	TEMPLE = "Temple.png",
	SHALLOW_SEA_BIG_FISHING_BOAT = "Big_Fishing_Boat_Shallow.png",
	DEEP_SEA_BIG_FISHING_BOAT = "Big_Fishing_Boat_Deep.png",
	APOTHECARY = "Apothecary.png",

	SILVER_MINE = "Silver_Mine.png",
	LIGHTHOUSE = "Lighthouse_Grass.png",
	SHALLOW_SEA_ROCKS_LIGHTHOUSE = "Lighthouse_Sea.png",
	COUNTRY_HOUSE = "Country_House.png",
	PUMPKIN_FARM = "Farm_Pumpkin.png",
	PUMPKIN_FIELD = "Field_Pumpkin.png",
	BIG_SHIPYARD = "Shipyard_Big.png",
	FISHERMANS_HUT = "Fishermans_Hut.png",
	FISHING_VILLAGE = "Fishing_Village.png",
	SCULPTOR = "Sculptor.png",
	ROOF_TILE_FACTORY = "Roof_Tile_Factory.png",
	SEAWEED_FARM = "Seaweed_Farm.png",
	TURKEY_FARM = "Turkey_Farm.png",
	MINT = "Mint.png",
	BANQUET = "Banquet.png",
	MINSTRELS_PODIUM = "Minstrels_Podium.png",
	MONOLITH_CIRCLE = "Monolith_Circle.png",
	LUCKY_CAULDRON = "Lucky_Cauldron.png",
	HILLS_BLAST_FURNACE = "Blast_Furnace_Hills.png",
	MOUNTAINS_BLAST_FURNACE = "Blast_Furnace_Mountains.png",
	STORAGE_OVERSEER = "Storage_Overseer.png",
	ARMAMENTS_TRADER = "Armaments_Trader.png",
	HILLS_LOOKOUT_TOWER = "Lookout_Tower_Hills.png",
	MOUNTAINS_LOOKOUT_TOWER = "Lookout_Tower_Mountains.png",
	PEA_PATCH = "Pea_Patch.png",
	MANOR = "Manor.png",
	LARGE_BREWERY = "Large_Brewery.png",
	GREAT_WAREHOUSE = "Great_Warehouse.png",
	APPLE_ORCHARD = "Apple_Orchard.png",
	FORESTER_COTTAGE = "Forester_Cottage.png",
	RATIONS_SUPPLIER = "Rations_Supplier.png",
	MILITARY_ACADEMY = "Military_Academy.png",
	MILITIA = "Militia.png",
	SUPPLY_CART = "Supply_Cart.png",
	SUPPLY_CARAVAN = "Supply_Caravan.png",
	ARCHERS = "Archers.png",
	LIGHT_CAVALRY = "Light_Cavalry.png",
	RANGERS = "Rangers.png",
	COMMAND_POST = "Command_Post.png",
	MILITARY_SHIPYARD = "Military_Shipyard.png",
	SUPPLY_BOAT = "Supply_Boat.png",
	PATROL_BOAT = "Patrol_Boat.png",
	FIRE_GALLEY = "Fire_Galley.png",

	DARKWOOD_LUMBER_MILL = "Darkwood_Lumber_Mill.png",
	TOYMAKERS_WORKSHOP = "Toymakers_Workshop.png",
	RABBIT_FARM = "Rabbit_Farm.png",
	RAFT = "Raft.png",
	BOTTLETRAP = "Bottletrap.png",
	FORTRESS = "Fortress.png",
	FIRE_FESTIVAL_PYRE = "Fire_Festival_Pyre.png",
	ENKINDLED_HOUSEHOLD = "Enkindled_Household.png",
	BOUNTIFUL_MARKETPLACE = "Bountiful_Marketplace.png",
	SOLSTICE_WINDMILL = "Solstice_Windmill.png",
	HUNTING_CAMP = "Hunting_Camp.png",
	HIGHLAND_HUNTER = "Highland_Hunter.png",
	SHEPHERDS_LODGE = "Shepherds_Lodge.png",
	HAUNTED_MANSION = "Haunted_Mansion.png",
	CORSAIR_SHIP = "Corsair_Ship.png",

	// Kubo 1
	PARTLY_DEMOLISHED_INN1 = "POI_Inn_Demolished_1.png",
	HILL_GALLOWS1 = "POI_Hill_Gallows_1.png",
	CAMP_SIEGE1 = "POI_Camp_Siege_1.png",
	CAMP_SIEGE2 = "POI_Camp_Siege_2.png",
	CAMP_SIEGE3 = "POI_Camp_Siege_3.png",
	CAMP_SIEGE4 = "POI_Camp_Siege_4.png",
	MONASTERY_ABANDONED1 = "POI_Monastery_Abandoned_1.png",
	MONASTERY_ABANDONED2 = "POI_Monastery_Abandoned_2.png",
	MONASTERY_ABANDONED3 = "POI_Monastery_Abandoned_3.png",
	MONASTERY_ABANDONED4 = "POI_Monastery_Abandoned_4.png",
	FOREST_WHISPERING1 = "POI_Forest_Whispering_1.png",
	FOREST_WHISPERING2 = "POI_Forest_Whispering_2.png",
	FOREST_WHISPERING3 = "POI_Forest_Whispering_3.png",
	FOREST_WHISPERING4 = "POI_Forest_Whispering_4.png",
	FOREST_WHISPERING5 = "POI_Forest_Whispering_5.png",
	FOREST_WHISPERING6 = "POI_Forest_Whispering_6.png",
	FOREST_WHISPERING7 = "POI_Forest_Whispering_7.png",
	FOREST_WHISPERING8 = "POI_Forest_Whispering_8.png",
	FOREST_WHISPERING9 = "POI_Forest_Whispering_9.png",
	WATERFALL1 = "POI_Waterfall_1.png",
	WATERFALL2 = "POI_Waterfall_2.png",
	SPRING_SACRED1 = "POI_Spring_Sacred_1.png",
	WATCHPOST_BURNED1 = "POI_Watchpost_Burned_1.png",
	TREE_ANCIENT1 = "POI_Tree_Ancient_1.png",
	CARAVAN_RUINS1 = "POI_Caravan_Ruins_1.png",
	CARAVAN_RUINS2 = "POI_Caravan_Ruins_2.png",
	CRYPT_NOBLE1 = "POI_Crypt_Noble_1.png",
	CRYPT_NOBLE2 = "POI_Crypt_Noble_2.png",
	STORAGE_ABANDONED1 = "POI_Storage_Abandoned_1.png",
	STORAGE_ABANDONED2 = "POI_Storage_Abandoned_2.png",
	CAVE_SHADOWS1 = "POI_Cave_Shadows_1.png",
	SUNDIAL_FORGOTTEN1 = "POI_Sundial_Forgotten_1.png",
	ALCHEMIST_ABANDONED1 = "POI_Alchemist_Abandoned_1.png",
	ALCHEMIST_ABANDONED2 = "POI_Alchemist_Abandoned_2.png",
	ALCHEMIST_ABANDONED3 = "POI_Alchemist_Abandoned_3.png",
	ALCHEMIST_ABANDONED4 = "POI_Alchemist_Abandoned_4.png",
	FORTRESS_SUNKEN1 = "POI_Fortress_Sunken_1.png",
	FORTRESS_SUNKEN2 = "POI_Fortress_Sunken_2.png",
	FORTRESS_SUNKEN3 = "POI_Fortress_Sunken_3.png",
	FORTRESS_SUNKEN4 = "POI_Fortress_Sunken_4.png",
	QUARRY_FLOODED1 = "POI_Quarry_Flooded_1.png",
	QUARRY_FLOODED2 = "POI_Quarry_Flooded_2.png",
	QUARRY_FLOODED3 = "POI_Quarry_Flooded_3.png",
	QUARRY_FLOODED4 = "POI_Quarry_Flooded_4.png",
	MONUMENT_MEGALITHIC1 = "POI_Monument_Megalithic_1.png",
	MONUMENT_MEGALITHIC2 = "POI_Monument_Megalithic_2.png",
	MONUMENT_MEGALITHIC3 = "POI_Monument_Megalithic_3.png",
	MONUMENT_MEGALITHIC4 = "POI_Monument_Megalithic_4.png",
	WHIRLPOOL1 = "POI_Whirlpool_1.png",
	WHIRLPOOL2 = "POI_Whirlpool_2.png",
	WHIRLPOOL3 = "POI_Whirlpool_3.png",
	WHIRLPOOL4 = "POI_Whirlpool_4.png",
	CASTAWAY_ISLAND1 = "POI_Castaway_Island_1.png",
	OUTPOST_SEA1 = "POI_Outpost_Sea_1.png",
	OUTPOST_SEA2 = "POI_Outpost_Sea_2.png",
	OUTPOST_SEA3 = "POI_Outpost_Sea_3.png",
	OUTPOST_SEA4 = "POI_Outpost_Sea_4.png",
	KEEP_DESERTED1 = "POI_Keep_Deserted_1.png",
	KEEP_DESERTED2 = "POI_Keep_Deserted_2.png",
	KEEP_DESERTED3 = "POI_Keep_Deserted_3.png",
	KEEP_DESERTED4 = "POI_Keep_Deserted_4.png",
	MOBY_DICK1 = "POI_Moby_Dick_1.png",
	MOBY_DICK2 = "POI_Moby_Dick_2.png",
	MOBY_DICK3 = "POI_Moby_Dick_3.png",
	MOBY_DICK4 = "POI_Moby_Dick_4.png",
	BIG_MUSHROOM1 = "POI_Big_Mushroom_1.png",
	BIG_MUSHROOM2 = "POI_Big_Mushroom_2.png",
	BIG_MUSHROOM3 = "POI_Big_Mushroom_3.png",
	BIG_MUSHROOM4 = "POI_Big_Mushroom_4.png",
	ASSASINS_HIDEOUT1 = "POI_Assasins_Hideout_1.png",
	ASSASINS_HIDEOUT2 = "POI_Assasins_Hideout_2.png",
	ASSASINS_HIDEOUT3 = "POI_Assasins_Hideout_3.png",
	ASSASINS_HIDEOUT4 = "POI_Assasins_Hideout_4.png",
	PIRATES_HIDEOUT1 = "POI_Pirates_Hideout_1.png",
	PIRATES_HIDEOUT2 = "POI_Pirates_Hideout_2.png",
	PIRATES_HIDEOUT3 = "POI_Pirates_Hideout_3.png",
	PIRATES_HIDEOUT4 = "POI_Pirates_Hideout_4.png",
	PIRATES_HIDEOUT5 = "POI_Pirates_Hideout_5.png",
	PIRATES_HIDEOUT6 = "POI_Pirates_Hideout_6.png",
	PIRATES_HIDEOUT7 = "POI_Pirates_Hideout_7.png",
	PIRATES_HIDEOUT8 = "POI_Pirates_Hideout_8.png",
	PIRATES_HIDEOUT9 = "POI_Pirates_Hideout_9.png",
	ASTRONOMER_HIDEOUT1 = "POI_Astronomer_Hideout_1.png",
	ASTRONOMER_HIDEOUT2 = "POI_Astronomer_Hideout_2.png",
	ASTRONOMER_HIDEOUT3 = "POI_Astronomer_Hideout_3.png",
	ASTRONOMER_HIDEOUT4 = "POI_Astronomer_Hideout_4.png",
	MOUNTAIN_LAKE1 = "POI_Mountain_Lake_1.png",
	MOUNTAIN_LAKE2 = "POI_Mountain_Lake_2.png",
	MOUNTAIN_LAKE3 = "POI_Mountain_Lake_3.png",
	MOUNTAIN_LAKE4 = "POI_Mountain_Lake_4.png",
	ATOL1 = "POI_Atol_1.png",
	ATOL2 = "POI_Atol_2.png",
	ATOL3 = "POI_Atol_3.png",
	ATOL4 = "POI_Atol_4.png",
	ATOL5 = "POI_Atol_5.png",
	ATOL6 = "POI_Atol_6.png",
	ATOL7 = "POI_Atol_7.png",
	ATOL8 = "POI_Atol_8.png",
	ATOL9 = "POI_Atol_9.png",
	BEAR_SKELETON1 = "POI_Carcass_Of_Huge_Bear_1.png",
	CRATER1 = "POI_Crater_1.png",
	CRATER2 = "POI_Crater_2.png",
	CRATER3 = "POI_Crater_3.png",
	CRATER4 = "POI_Crater_4.png",
	PLAGUED_FOREST1 = "POI_Plagued_Forest_1.png",
	PLAGUED_FOREST2 = "POI_Plagued_Forest_2.png",
	PLAGUED_FOREST3 = "POI_Plagued_Forest_3.png",
	PLAGUED_FOREST4 = "POI_Plagued_Forest_4.png",
	MENHIR1 = "POI_Menhir_1.png",
	MENHIR2 = "POI_Menhir_2.png",
	FALCONERS_TOWER1 = "POI_Falcon_Tower_1.png",
	FALCONERS_TOWER2 = "POI_Falcon_Tower_2.png",
	TERRACE_GARDENS1 = "POI_Terrace_Gardens_1.png",
	TERRACE_GARDENS2 = "POI_Terrace_Gardens_2.png",
	TERRACE_GARDENS3 = "POI_Terrace_Gardens_3.png",
	TERRACE_GARDENS4 = "POI_Terrace_Gardens_4.png",
	TERRACE_GARDENS5 = "POI_Terrace_Gardens_5.png",
	TERRACE_GARDENS6 = "POI_Terrace_Gardens_6.png",
	TERRACE_GARDENS7 = "POI_Terrace_Gardens_7.png",
	TERRACE_GARDENS8 = "POI_Terrace_Gardens_8.png",
	TERRACE_GARDENS9 = "POI_Terrace_Gardens_9.png",
	KRAKEN1 = "POI_Kraken_1.png",
	KRAKEN2 = "POI_Kraken_2.png",
	KRAKEN3 = "POI_Kraken_3.png",
	KRAKEN4 = "POI_Kraken_4.png",
	WITCH_LAKE1 = "POI_Witch_Lake_1.png",
	GEYSER1 = "POI_Geyser_1.png",
	GEYSER2 = "POI_Geyser_2.png",
	GEYSER3 = "POI_Geyser_3.png",
	GEYSER4 = "POI_Geyser_4.png",
}

export const tilerepoLayer0FrameNames = new Set<FrameName>([
	FrameName.GRASSLAND,
	FrameName.GRASSLAND1,
	FrameName.GRASSLAND2,
	FrameName.GRASSLAND3,
	FrameName.GRASSLAND4,
	FrameName.RUINED_FOREST,
	FrameName.SETTLEMENT_EMPTY,
	FrameName.SETTLEMENT_EMPTY1,
	FrameName.SETTLEMENT_EMPTY2,
	FrameName.SETTLEMENT_EMPTY3,
	FrameName.SETTLEMENT_EMPTY4,
	FrameName.SETTLEMENT_EMPTY5,
	FrameName.SETTLEMENT_EMPTY6,
	FrameName.SETTLEMENT_EMPTY7,
	FrameName.SETTLEMENT_EMPTY8,
	FrameName.SETTLEMENT_EMPTY9,
	FrameName.SETTLEMENT_EMPTY10,
	FrameName.SETTLEMENT_EMPTY11,
	FrameName.SETTLEMENT_EMPTY12,
	FrameName.SETTLEMENT_EMPTY13,
	FrameName.SETTLEMENT_EMPTY14,
	FrameName.SETTLEMENT_EMPTY15,
	FrameName.SETTLEMENT_EMPTY16,
	FrameName.SETTLEMENT_EMPTY17,
	FrameName.SETTLEMENT_EMPTY18,
	FrameName.SETTLEMENT_EMPTY19,
	FrameName.FOREST,
	FrameName.DENSE_FOREST,
	FrameName.OLD_FOREST,
	FrameName.HILLS,
	FrameName.MOUNTAINS,
	FrameName.IRON_MOUNTAINS,
	FrameName.SWAMP,
	FrameName.GOLD_VEIN,
	FrameName.GEMS_VEIN,
	FrameName.COAL_DEPOSIT,
	FrameName.SALT_DEPOSIT,
	FrameName.RIVER10,
	FrameName.RIVER5,
	FrameName.RIVER12,
	FrameName.RIVER9,
	FrameName.RIVER3,
	FrameName.RIVER6,
	FrameName.RIVER14,
	FrameName.RIVER13,
	FrameName.RIVER11,
	FrameName.RIVER7,
	FrameName.RIVER15,
	FrameName.RIVER_SPRING2,
	FrameName.RIVER_SPRING4,
	FrameName.RIVER_SPRING8,
	FrameName.RIVER_SPRING1,
	FrameName.RIVER_DELTA2,
	FrameName.RIVER_DELTA4,
	FrameName.RIVER_DELTA8,
	FrameName.RIVER_DELTA1,
	FrameName.SHALLOW_SEA,
	FrameName.SHALLOW_SEA_ROCKS,
	FrameName.SHALLOW_SEA_SMALL_FISH,
	FrameName.SHALLOW_SEA_MEDIUM_FISH,
	FrameName.SHALLOW_SEA_CORAL_REEF,
	FrameName.DEEP_SEA,
	FrameName.DEEP_SEA_MEDIUM_FISH,
	FrameName.DEEP_SEA_BIG_FISH,
	FrameName.DEEP_SEA_CORAL_REEF,

	// Kubo 2
	FrameName.PARTLY_DEMOLISHED_INN1,
	FrameName.HILL_GALLOWS1,
	FrameName.CAMP_SIEGE1,
	FrameName.CAMP_SIEGE2,
	FrameName.CAMP_SIEGE3,
	FrameName.CAMP_SIEGE4,
	FrameName.MONASTERY_ABANDONED1,
	FrameName.MONASTERY_ABANDONED2,
	FrameName.MONASTERY_ABANDONED3,
	FrameName.MONASTERY_ABANDONED4,
	FrameName.FOREST_WHISPERING1,
	FrameName.FOREST_WHISPERING2,
	FrameName.FOREST_WHISPERING3,
	FrameName.FOREST_WHISPERING4,
	FrameName.FOREST_WHISPERING5,
	FrameName.FOREST_WHISPERING6,
	FrameName.FOREST_WHISPERING7,
	FrameName.FOREST_WHISPERING8,
	FrameName.FOREST_WHISPERING9,
	FrameName.WATERFALL1,
	FrameName.WATERFALL2,
	FrameName.SPRING_SACRED1,
	FrameName.WATCHPOST_BURNED1,
	FrameName.TREE_ANCIENT1,
	FrameName.CARAVAN_RUINS1,
	FrameName.CARAVAN_RUINS2,
	FrameName.CRYPT_NOBLE1,
	FrameName.CRYPT_NOBLE2,
	FrameName.STORAGE_ABANDONED1,
	FrameName.STORAGE_ABANDONED2,
	FrameName.CAVE_SHADOWS1,
	FrameName.SUNDIAL_FORGOTTEN1,
	FrameName.ALCHEMIST_ABANDONED1,
	FrameName.ALCHEMIST_ABANDONED2,
	FrameName.ALCHEMIST_ABANDONED3,
	FrameName.ALCHEMIST_ABANDONED4,
	FrameName.FORTRESS_SUNKEN1,
	FrameName.FORTRESS_SUNKEN2,
	FrameName.FORTRESS_SUNKEN3,
	FrameName.FORTRESS_SUNKEN4,
	FrameName.QUARRY_FLOODED1,
	FrameName.QUARRY_FLOODED2,
	FrameName.QUARRY_FLOODED3,
	FrameName.QUARRY_FLOODED4,
	FrameName.MONUMENT_MEGALITHIC1,
	FrameName.MONUMENT_MEGALITHIC2,
	FrameName.MONUMENT_MEGALITHIC3,
	FrameName.MONUMENT_MEGALITHIC4,
	FrameName.WHIRLPOOL1,
	FrameName.WHIRLPOOL2,
	FrameName.WHIRLPOOL3,
	FrameName.WHIRLPOOL4,
	FrameName.CASTAWAY_ISLAND1,
	FrameName.OUTPOST_SEA1,
	FrameName.OUTPOST_SEA2,
	FrameName.OUTPOST_SEA3,
	FrameName.OUTPOST_SEA4,
	FrameName.KEEP_DESERTED1,
	FrameName.KEEP_DESERTED2,
	FrameName.KEEP_DESERTED3,
	FrameName.KEEP_DESERTED4,
	FrameName.MOBY_DICK1,
	FrameName.MOBY_DICK2,
	FrameName.MOBY_DICK3,
	FrameName.MOBY_DICK4,
	FrameName.BIG_MUSHROOM1,
	FrameName.BIG_MUSHROOM2,
	FrameName.BIG_MUSHROOM3,
	FrameName.BIG_MUSHROOM4,
	FrameName.ASSASINS_HIDEOUT1,
	FrameName.ASSASINS_HIDEOUT2,
	FrameName.ASSASINS_HIDEOUT3,
	FrameName.ASSASINS_HIDEOUT4,
	FrameName.PIRATES_HIDEOUT1,
	FrameName.PIRATES_HIDEOUT2,
	FrameName.PIRATES_HIDEOUT3,
	FrameName.PIRATES_HIDEOUT4,
	FrameName.PIRATES_HIDEOUT5,
	FrameName.PIRATES_HIDEOUT6,
	FrameName.PIRATES_HIDEOUT7,
	FrameName.PIRATES_HIDEOUT8,
	FrameName.PIRATES_HIDEOUT9,
	FrameName.ASTRONOMER_HIDEOUT1,
	FrameName.ASTRONOMER_HIDEOUT2,
	FrameName.ASTRONOMER_HIDEOUT3,
	FrameName.ASTRONOMER_HIDEOUT4,
	FrameName.MOUNTAIN_LAKE1,
	FrameName.MOUNTAIN_LAKE2,
	FrameName.MOUNTAIN_LAKE3,
	FrameName.MOUNTAIN_LAKE4,
	FrameName.ATOL1,
	FrameName.ATOL2,
	FrameName.ATOL3,
	FrameName.ATOL4,
	FrameName.ATOL5,
	FrameName.ATOL6,
	FrameName.ATOL7,
	FrameName.ATOL8,
	FrameName.ATOL9,
	FrameName.BEAR_SKELETON1,
	FrameName.CRATER1,
	FrameName.CRATER2,
	FrameName.CRATER3,
	FrameName.CRATER4,
	FrameName.PLAGUED_FOREST1,
	FrameName.PLAGUED_FOREST2,
	FrameName.PLAGUED_FOREST3,
	FrameName.PLAGUED_FOREST4,
	FrameName.MENHIR1,
	FrameName.MENHIR2,
	FrameName.FALCONERS_TOWER1,
	FrameName.FALCONERS_TOWER2,
	FrameName.TERRACE_GARDENS1,
	FrameName.TERRACE_GARDENS2,
	FrameName.TERRACE_GARDENS3,
	FrameName.TERRACE_GARDENS4,
	FrameName.TERRACE_GARDENS5,
	FrameName.TERRACE_GARDENS6,
	FrameName.TERRACE_GARDENS7,
	FrameName.TERRACE_GARDENS8,
	FrameName.TERRACE_GARDENS9,
	FrameName.KRAKEN1,
	FrameName.KRAKEN2,
	FrameName.KRAKEN3,
	FrameName.KRAKEN4,
	FrameName.WITCH_LAKE1,
	FrameName.GEYSER1,
	FrameName.GEYSER2,
	FrameName.GEYSER3,
	FrameName.GEYSER4,
]);

export const tilerepoLayer1FrameNames = new Set<FrameName>([
	FrameName.PALISADE9_LEVEL1,
	FrameName.PALISADE1_LEVEL1,
	FrameName.PALISADE3_LEVEL1,

	FrameName.PALISADE9_LEVEL2,
	FrameName.PALISADE1_LEVEL2,
	FrameName.PALISADE3_LEVEL2,

	FrameName.PALISADE9_LEVEL3,
	FrameName.PALISADE1_LEVEL3,
	FrameName.PALISADE3_LEVEL3,

	FrameName.PALISADE9_LEVEL4,
	FrameName.PALISADE1_LEVEL4,
	FrameName.PALISADE3_LEVEL4,

	FrameName.PALISADE9_LEVEL5,
	FrameName.PALISADE1_LEVEL5,
	FrameName.PALISADE3_LEVEL5,

	FrameName.BEACH1,
	FrameName.BEACH2,
	FrameName.BEACH4,
	FrameName.BEACH5,
	FrameName.BEACH8,
	FrameName.BEACH10,
	FrameName.BEACH12,
	FrameName.BEACH16,
	FrameName.BEACH17,
	FrameName.BEACH18,
	FrameName.BEACH24,
	FrameName.BEACH26,
	FrameName.BEACH32,
	FrameName.BEACH33,
	FrameName.BEACH34,
	FrameName.BEACH36,
	FrameName.BEACH37,
	FrameName.BEACH48,
	FrameName.BEACH49,
	FrameName.BEACH50,
	FrameName.BEACH64,
	FrameName.BEACH65,
	FrameName.BEACH66,
	FrameName.BEACH68,
	FrameName.BEACH69,
	FrameName.BEACH72,
	FrameName.BEACH74,
	FrameName.BEACH76,
	FrameName.BEACH80,
	FrameName.BEACH81,
	FrameName.BEACH82,
	FrameName.BEACH88,
	FrameName.BEACH90,
	FrameName.BEACH128,
	FrameName.BEACH129,
	FrameName.BEACH130,
	FrameName.BEACH132,
	FrameName.BEACH133,
	FrameName.BEACH136,
	FrameName.BEACH138,
	FrameName.BEACH140,
	FrameName.BEACH160,
	FrameName.BEACH161,
	FrameName.BEACH162,
	FrameName.BEACH164,
	FrameName.BEACH165,
]);

export const tilerepoSettlementCastleBuildingsFrameNames = new Set<FrameName>([
	FrameName.SETTLEMENT_CASTLE,
	FrameName.SETTLEMENT_CASTLE_LEVEL1,
	FrameName.SETTLEMENT_CASTLE_LEVEL2,
	FrameName.SETTLEMENT_CASTLE_LEVEL3,
	FrameName.SETTLEMENT_CASTLE_LEVEL4,
	FrameName.SETTLEMENT_CASTLE_LEVEL5,
	FrameName.SETTLEMENT_CASTLE_LEVEL6,
	FrameName.SETTLEMENT_CASTLE_LEVEL7,
	FrameName.SETTLEMENT_CASTLE_LEVEL8,
	FrameName.SETTLEMENT_CASTLE_LEVEL9,
	FrameName.SETTLEMENT_CASTLE_LEVEL10,
]);

export const tilerepoLayer2FrameNames = new Set<FrameName>([
	...tilerepoSettlementCastleBuildingsFrameNames,
	FrameName.WHEAT_FIELD,
	FrameName.HOPS_FIELD,
	FrameName.CATTLE_RANGE,
	FrameName.CATTLE_RANGE_SPECIAL,
	FrameName.PUMPKIN_FIELD,
	FrameName.SEAWEED_FIELD,
	FrameName.APPLE_GROVE,
	FrameName.DEPLETED_FIELD,
	FrameName.ABANDONED_HUT,
	FrameName.BURNED_HOUSE,
	FrameName.OLD_BATTLEFIELD,
	FrameName.GRASSLAND_CASTLE_RUINS,
	FrameName.HILLS_CASTLE_RUINS,
	FrameName.MERCENARY_CAMP,
	FrameName.MERCHANT_SHIP,
	FrameName.SHALLOW_SEA_SHIPWRECK,
	FrameName.SHALLOW_SEA_ROCKS_SHIPWRECK,
	FrameName.MERCENARY_SHIP,
	FrameName.TRAVELLING_MERCHANT,
	FrameName.WOLFS_DEN,
	FrameName.BEARS_DEN,
	FrameName.FLOTSAM_JETSAM,
	FrameName.DAMAGED_MILL,
	FrameName.COLLAPSED_MINE,
	FrameName.HORNETS_NEST,
	FrameName.DIRT_ROAD_TUTORIAL,
	FrameName.DIRT_ROAD,
	FrameName.DIRT_ROAD_1,
	FrameName.DIRT_ROAD_2,
	FrameName.DIRT_ROAD_3,
	FrameName.DIRT_ROAD_4,
	FrameName.DIRT_ROAD_5,
	FrameName.DIRT_ROAD_6,
	FrameName.DIRT_ROAD_7,
	FrameName.DIRT_ROAD_8,
	FrameName.DIRT_ROAD_9,
	FrameName.DIRT_ROAD_10,
	FrameName.DIRT_ROAD_11,
	FrameName.GRAVEL_ROAD_1,
	FrameName.GRAVEL_ROAD,
	FrameName.GRAVEL_ROAD_2,
	FrameName.GRAVEL_ROAD_3,
	FrameName.GRAVEL_ROAD_4,
	FrameName.GRAVEL_ROAD_5,
	FrameName.GRAVEL_ROAD_6,
	FrameName.GRAVEL_ROAD_7,
	FrameName.GRAVEL_ROAD_8,
	FrameName.GRAVEL_ROAD_9,
	FrameName.GRAVEL_ROAD_10,
	FrameName.GRAVEL_ROAD_11,
	FrameName.COBBLED_ROAD,
	FrameName.COBBLED_ROAD_1,
	FrameName.COBBLED_ROAD_2,
	FrameName.COBBLED_ROAD_3,
	FrameName.COBBLED_ROAD_4,
	FrameName.COBBLED_ROAD_5,
	FrameName.COBBLED_ROAD_6,
	FrameName.COBBLED_ROAD_7,
	FrameName.COBBLED_ROAD_8,
	FrameName.COBBLED_ROAD_9,
	FrameName.COBBLED_ROAD_10,
	FrameName.COBBLED_ROAD_11,
	FrameName.FORD_CROSSING,
	FrameName.FORD_CROSSING_1,
	FrameName.FORD_CROSSING_2,
	FrameName.WOODEN_BRIDGE,
	FrameName.WOODEN_BRIDGE_1,
	FrameName.WOODEN_BRIDGE_2,
	FrameName.STONE_BRIDGE,
	FrameName.STONE_BRIDGE_1,
	FrameName.STONE_BRIDGE_2,
	FrameName.MOUNTAIN_ROAD,
	FrameName.HILLY_ROAD,

	FrameName.GATHERERS_HUT,
	FrameName.LUMBER_MILL,
	FrameName.SMALL_HOUSES,
	FrameName.WHEAT_FARM,
	FrameName.GOLD_MINE,
	FrameName.PREMIUM_GOLD_MINE,
	FrameName.STONE_QUARRY,
	FrameName.BAKERY,
	FrameName.INDUSTRIAL_LUMBER_MILL,
	FrameName.SHIPYARD,
	FrameName.SHALLOW_SEA_FISHING_BOAT,
	FrameName.DEEP_SEA_FISHING_BOAT,
	FrameName.TOLL_HOUSE,
	FrameName.CLAY_PIT,
	FrameName.SMALL_STOCKPILE,
	FrameName.IRON_MINE,
	FrameName.FURNACE,
	FrameName.MILL,
	FrameName.OXEN_STABLE,
	FrameName.BLACKSMITH,
	FrameName.MARKET,
	FrameName.SHALLOW_SEA_SMALL_FISH_TRAP,
	FrameName.SHALLOW_SEA_MEDIUM_FISH_TRAP,
	FrameName.FOUNDRY,
	FrameName.WAREHOUSE,
	FrameName.UNIVERSAL_WAREHOUSE,
	FrameName.TOOLMAKER,
	FrameName.ARMORY,
	FrameName.BARRACKS,
	FrameName.OUTPOST,
	FrameName.HEALERS_HUT,
	FrameName.HUNTERS_LODGE,
	FrameName.TANNERY,
	FrameName.TAILORS_WORKSHOP,
	FrameName.LARGE_STONE_QUARRY,
	FrameName.MEDIUM_HOUSES,
	FrameName.BANDIT_CAMP_SMALL,
	FrameName.BANDIT_CAMP_MEDIUM,
	FrameName.BANDIT_CAMP_LARGE,
	FrameName.SHALLOW_SEA_SMALL_PIRATES,
	FrameName.DEEP_SEA_SMALL_PIRATES,
	FrameName.SHALLOW_SEA_MEDIUM_PIRATES,
	FrameName.DEEP_SEA_MEDIUM_PIRATES,
	FrameName.LARGE_CLAY_PIT,
	FrameName.GEMS_MINE,
	FrameName.LIVESTOCK_FARM,
	FrameName.UNIVERSITY,
	FrameName.ADVANCED_IRON_MINE,
	FrameName.HILLS_SCOUT_TOWER,
	FrameName.MOUNTAINS_SCOUT_TOWER,
	FrameName.BREWERY,
	FrameName.INN,
	FrameName.SHOEMAKER,
	FrameName.PATISSERIE,
	FrameName.GUARD_TOWER,
	FrameName.CARPENTRY_DISTRICT,
	FrameName.STONEMASONRY_DISTRICT,
	FrameName.TAX_OFFICE,
	FrameName.LARGE_HOUSES,
	FrameName.ARTISAN_SMITH,
	FrameName.WATER_SAW_MILL,
	FrameName.INDUSTRIAL_FOUNDRY,
	FrameName.ARENA,
	FrameName.MOUNTAIN_BELLOWS,
	FrameName.WATER_MILL,
	FrameName.BRICKYARD,
	FrameName.FLETCHER,
	FrameName.ARCHERY_RANGE,
	FrameName.SHALLOW_SEA_PEARL_HUNTER,
	FrameName.DEEP_SEA_PEARL_HUNTER,
	FrameName.WARRIORS_ENEMY,
	FrameName.BARRICADE_ENEMY,
	FrameName.CAPTAIN_ENEMY,
	FrameName.CHIEFTAIN_ENEMY,
	FrameName.SHALLOW_SEA_RAIDERS_SKIFF,
	FrameName.SHALLOW_SEA_RAIDERS_GALLEY,
	FrameName.SHALLOW_SEA_RAIDERS_FLAGSHIP,
	FrameName.PORT,
	FrameName.BATH_HOUSE,
	FrameName.GOLD_PROSPECTOR,
	FrameName.APIARY,
	FrameName.CANDLEMAKER,
	FrameName.SADDLER,
	FrameName.STABLES,
	FrameName.TEMPLE,
	FrameName.SHALLOW_SEA_BIG_FISHING_BOAT,
	FrameName.DEEP_SEA_BIG_FISHING_BOAT,
	FrameName.APOTHECARY,
	FrameName.HILLS_BLAST_FURNACE,
	FrameName.MOUNTAINS_BLAST_FURNACE,
	FrameName.STORAGE_OVERSEER,
	FrameName.ARMAMENTS_TRADER,
	FrameName.HILLS_LOOKOUT_TOWER,
	FrameName.MOUNTAINS_LOOKOUT_TOWER,
	FrameName.PEA_PATCH,
	FrameName.MANOR,
	FrameName.LARGE_BREWERY,
	FrameName.GREAT_WAREHOUSE,
	FrameName.APPLE_ORCHARD,
	FrameName.FORESTER_COTTAGE,

	FrameName.SILVER_MINE,
	FrameName.LIGHTHOUSE,
	FrameName.SHALLOW_SEA_ROCKS_LIGHTHOUSE,
	FrameName.COUNTRY_HOUSE,
	FrameName.PUMPKIN_FARM,
	FrameName.BIG_SHIPYARD,
	FrameName.FISHERMANS_HUT,
	FrameName.FISHING_VILLAGE,
	FrameName.SCULPTOR,
	FrameName.ROOF_TILE_FACTORY,
	FrameName.SEAWEED_FARM,
	FrameName.TURKEY_FARM,
	FrameName.MINT,
	FrameName.BANQUET,
	FrameName.MINSTRELS_PODIUM,
	FrameName.MONOLITH_CIRCLE,
	FrameName.LUCKY_CAULDRON,

	FrameName.RATIONS_SUPPLIER,
	FrameName.MILITARY_ACADEMY,
	FrameName.MILITIA,
	FrameName.SUPPLY_CART,
	FrameName.SUPPLY_CARAVAN,
	FrameName.ARCHERS,
	FrameName.LIGHT_CAVALRY,
	FrameName.RANGERS,
	FrameName.COMMAND_POST,
	FrameName.MILITARY_SHIPYARD,
	FrameName.SUPPLY_BOAT,
	FrameName.PATROL_BOAT,
	FrameName.FIRE_GALLEY,

	FrameName.DARKWOOD_LUMBER_MILL,
	FrameName.TOYMAKERS_WORKSHOP,
	FrameName.RABBIT_FARM,
	FrameName.RAFT,
	FrameName.BOTTLETRAP,
	FrameName.FORTRESS,
	FrameName.FIRE_FESTIVAL_PYRE,
	FrameName.ENKINDLED_HOUSEHOLD,
	FrameName.BOUNTIFUL_MARKETPLACE,
	FrameName.SOLSTICE_WINDMILL,
	FrameName.HUNTING_CAMP,
	FrameName.HIGHLAND_HUNTER,
	FrameName.SHEPHERDS_LODGE,
	FrameName.HAUNTED_MANSION,
	FrameName.CORSAIR_SHIP,
]);

export const tilerepoLayer3FrameNames = new Set<FrameName>([
	FrameName.PALISADE8_LEVEL1,
	FrameName.PALISADE2_LEVEL1,
	FrameName.PALISADE12_LEVEL1,
	FrameName.PALISADE4_LEVEL1,
	FrameName.PALISADE6_LEVEL1,

	FrameName.PALISADE8_LEVEL2,
	FrameName.PALISADE2_LEVEL2,
	FrameName.PALISADE12_LEVEL2,
	FrameName.PALISADE4_LEVEL2,
	FrameName.PALISADE6_LEVEL2,

	FrameName.PALISADE8_LEVEL3,
	FrameName.PALISADE2_LEVEL3,
	FrameName.PALISADE12_LEVEL3,
	FrameName.PALISADE4_LEVEL3,
	FrameName.PALISADE6_LEVEL3,

	FrameName.PALISADE8_LEVEL4,
	FrameName.PALISADE2_LEVEL4,
	FrameName.PALISADE12_LEVEL4,
	FrameName.PALISADE4_LEVEL4,
	FrameName.PALISADE6_LEVEL4,

	FrameName.PALISADE8_LEVEL5,
	FrameName.PALISADE2_LEVEL5,
	FrameName.PALISADE12_LEVEL5,
	FrameName.PALISADE4_LEVEL5,
	FrameName.PALISADE6_LEVEL5,
]);

export const tilerepoSettlementEmptyFrameNames = new Set<FrameName>([
	FrameName.SETTLEMENT_EMPTY,
	FrameName.SETTLEMENT_EMPTY1,
	FrameName.SETTLEMENT_EMPTY2,
	FrameName.SETTLEMENT_EMPTY3,
	FrameName.SETTLEMENT_EMPTY4,
	FrameName.SETTLEMENT_EMPTY5,
	FrameName.SETTLEMENT_EMPTY6,
	FrameName.SETTLEMENT_EMPTY7,
	FrameName.SETTLEMENT_EMPTY8,
	FrameName.SETTLEMENT_EMPTY9,
	FrameName.SETTLEMENT_EMPTY10,
	FrameName.SETTLEMENT_EMPTY11,
	FrameName.SETTLEMENT_EMPTY12,
	FrameName.SETTLEMENT_EMPTY13,
	FrameName.SETTLEMENT_EMPTY14,
	FrameName.SETTLEMENT_EMPTY15,
	FrameName.SETTLEMENT_EMPTY16,
	FrameName.SETTLEMENT_EMPTY17,
	FrameName.SETTLEMENT_EMPTY18,
	FrameName.SETTLEMENT_EMPTY19,
]);

// TODO: prejst vsetky tieto male groupy a zmazat nepouzivane

export const tilerepoGrasslandFrameNames = new Set<FrameName>([
	FrameName.GRASSLAND,
	FrameName.GRASSLAND1,
	FrameName.GRASSLAND2,
	FrameName.GRASSLAND3,
	FrameName.GRASSLAND4,
]);

export const tilerepoForestFrameNames = new Set<FrameName>([
	FrameName.FOREST,
	FrameName.DENSE_FOREST,
	FrameName.OLD_FOREST,
]);

export const tilerepoFarmsFrameNames = new Set<FrameName>([
	FrameName.WHEAT_FARM,
	FrameName.LIVESTOCK_FARM,
	FrameName.BREWERY,
	FrameName.PUMPKIN_FARM,
	FrameName.SEAWEED_FARM,
	FrameName.LARGE_BREWERY,
	FrameName.APPLE_ORCHARD,
	// FrameName.SOLSTICE_WINDMILL, // nema metodu onTick, negenruje polia
]);

export const tilerepoFarmFieldsFrameNames = new Set<FrameName>([
	FrameName.WHEAT_FIELD,
	FrameName.HOPS_FIELD,
	FrameName.CATTLE_RANGE,
	FrameName.CATTLE_RANGE_SPECIAL, // not milka
	FrameName.PUMPKIN_FIELD,
	FrameName.SEAWEED_FIELD,
	FrameName.APPLE_GROVE,
]);

export const tilerepoSeasFrameNames = new Set<FrameName>([
	FrameName.DEEP_SEA,
	FrameName.DEEP_SEA_BIG_FISH,
	FrameName.DEEP_SEA_MEDIUM_FISH,
	FrameName.DEEP_SEA_CORAL_REEF,
	FrameName.SHALLOW_SEA,
	FrameName.SHALLOW_SEA_SMALL_FISH,
	FrameName.SHALLOW_SEA_MEDIUM_FISH,
	FrameName.SHALLOW_SEA_ROCKS,
	FrameName.SHALLOW_SEA_CORAL_REEF,
	FrameName.SHALLOW_SEA_SHIPWRECK,
	FrameName.SHALLOW_SEA_SMALL_PIRATES,
	FrameName.SHALLOW_SEA_MEDIUM_PIRATES,
]);

export const tilerepoRiversFrameNames = new Set<FrameName>([
	FrameName.RIVER10,
	FrameName.RIVER5,
	FrameName.RIVER12,
	FrameName.RIVER9,
	FrameName.RIVER3,
	FrameName.RIVER6,
	FrameName.RIVER14,
	FrameName.RIVER13,
	FrameName.RIVER11,
	FrameName.RIVER7,
	FrameName.RIVER15,
	FrameName.RIVER_SPRING2,
	FrameName.RIVER_SPRING4,
	FrameName.RIVER_SPRING8,
	FrameName.RIVER_SPRING1,
	FrameName.RIVER_DELTA2,
	FrameName.RIVER_DELTA4,
	FrameName.RIVER_DELTA8,
	FrameName.RIVER_DELTA1,
]);

export const tilerepoWaterFrameNames = new Set<FrameName>([
	...tilerepoSeasFrameNames,
	...tilerepoRiversFrameNames,
]);

export const tileRepoWheatFarmsFrameNames = new Set<FrameName>([
	FrameName.WHEAT_FARM,
]);

export const tileRepoBakeryFrameNames = new Set<FrameName>([FrameName.BAKERY]);

export const tileRepoBlacksmithFrameNames = new Set<FrameName>([
	FrameName.BLACKSMITH,
]);

export const tilerepoLumberMillsFrameNames = new Set<FrameName>([
	FrameName.LUMBER_MILL,
	FrameName.INDUSTRIAL_LUMBER_MILL,
	FrameName.WATER_SAW_MILL,
	FrameName.DARKWOOD_LUMBER_MILL,
]);

export const tilerepoFishingBoatsFrameNames = new Set<FrameName>([
	FrameName.SHALLOW_SEA_FISHING_BOAT,
	FrameName.DEEP_SEA_FISHING_BOAT,
]);

export const tilerepoBigFishingBoatsFrameNames = new Set<FrameName>([
	FrameName.SHALLOW_SEA_BIG_FISHING_BOAT,
	FrameName.DEEP_SEA_BIG_FISHING_BOAT,
]);

export const tilerepoAllFishingBoatsFrameNames = new Set<FrameName>([
	FrameName.SHALLOW_SEA_FISHING_BOAT,
	FrameName.DEEP_SEA_FISHING_BOAT,
	FrameName.SHALLOW_SEA_BIG_FISHING_BOAT,
	FrameName.DEEP_SEA_BIG_FISHING_BOAT,
]);

export const tilerepoFishTrapsFrameNames = new Set<FrameName>([
	FrameName.SHALLOW_SEA_SMALL_FISH_TRAP,
	FrameName.SHALLOW_SEA_MEDIUM_FISH_TRAP,
]);

export const tilerepoLightHousesFrameNames = new Set<FrameName>([
	FrameName.LIGHTHOUSE,
	FrameName.SHALLOW_SEA_ROCKS_LIGHTHOUSE,
]);

export const tilerepoCoralReefsFrameNames = new Set<FrameName>([
	FrameName.DEEP_SEA_CORAL_REEF,
	FrameName.SHALLOW_SEA_CORAL_REEF,
]);

export const tilerepoShipwrecksFrameNames = new Set<FrameName>([
	FrameName.SHALLOW_SEA_SHIPWRECK,
	FrameName.SHALLOW_SEA_ROCKS_SHIPWRECK,
]);

export const tilerepoPearlHuntersFrameNames = new Set<FrameName>([
	FrameName.SHALLOW_SEA_PEARL_HUNTER,
	FrameName.DEEP_SEA_PEARL_HUNTER,
]);

export const tilerepoMediumFishFrameNames = new Set<FrameName>([
	FrameName.SHALLOW_SEA_MEDIUM_FISH,
	FrameName.DEEP_SEA_MEDIUM_FISH,
]);

export const tilerepoCastleRuinsFrameNames = new Set<FrameName>([
	FrameName.GRASSLAND_CASTLE_RUINS,
	FrameName.HILLS_CASTLE_RUINS,
]);

export const tilerepoBlastFurnacesFrameNames = new Set<FrameName>([
	FrameName.HILLS_BLAST_FURNACE,
	FrameName.MOUNTAINS_BLAST_FURNACE,
]);

export const tilerepoLookoutTowersFrameNames = new Set<FrameName>([
	FrameName.HILLS_LOOKOUT_TOWER,
	FrameName.MOUNTAINS_LOOKOUT_TOWER,
]);

export const tilerepoForestsFrameNames = new Set<FrameName>([
	FrameName.FOREST,
	FrameName.DENSE_FOREST,
	FrameName.OLD_FOREST,
	FrameName.FOREST_WHISPERING1,
	FrameName.FOREST_WHISPERING2,
	FrameName.FOREST_WHISPERING3,
	FrameName.FOREST_WHISPERING4,
	FrameName.FOREST_WHISPERING5,
	FrameName.FOREST_WHISPERING6,
	FrameName.FOREST_WHISPERING7,
	FrameName.FOREST_WHISPERING8,
	FrameName.FOREST_WHISPERING9,
]);

export const tilerepoBuildingsFrameNames = new Set<FrameName>([
	...tilerepoSettlementCastleBuildingsFrameNames,
	FrameName.WHEAT_FIELD,
	FrameName.HOPS_FIELD,
	FrameName.CATTLE_RANGE,
	FrameName.CATTLE_RANGE_SPECIAL,
	FrameName.PUMPKIN_FIELD,
	FrameName.SEAWEED_FIELD,
	FrameName.APPLE_GROVE,
	FrameName.GATHERERS_HUT,
	FrameName.LUMBER_MILL,
	FrameName.SMALL_HOUSES,
	FrameName.WHEAT_FARM,
	FrameName.GOLD_MINE,
	FrameName.PREMIUM_GOLD_MINE,
	FrameName.STONE_QUARRY,
	FrameName.BAKERY,
	FrameName.INDUSTRIAL_LUMBER_MILL,
	FrameName.SHIPYARD,
	FrameName.SHALLOW_SEA_FISHING_BOAT,
	FrameName.DEEP_SEA_FISHING_BOAT,
	FrameName.TOLL_HOUSE,
	FrameName.CLAY_PIT,
	FrameName.SMALL_STOCKPILE,
	FrameName.IRON_MINE,
	FrameName.FURNACE,
	FrameName.MILL,
	FrameName.OXEN_STABLE,
	FrameName.BLACKSMITH,
	FrameName.MARKET,
	FrameName.SHALLOW_SEA_SMALL_FISH_TRAP,
	FrameName.SHALLOW_SEA_MEDIUM_FISH_TRAP,
	FrameName.FOUNDRY,
	FrameName.WAREHOUSE,
	FrameName.UNIVERSAL_WAREHOUSE,
	FrameName.TOOLMAKER,
	FrameName.ARMORY,
	FrameName.BARRACKS,
	FrameName.OUTPOST,
	FrameName.HEALERS_HUT,
	FrameName.HUNTERS_LODGE,
	FrameName.TANNERY,
	FrameName.TAILORS_WORKSHOP,
	FrameName.LARGE_STONE_QUARRY,
	FrameName.MEDIUM_HOUSES,
	FrameName.LARGE_CLAY_PIT,
	FrameName.GEMS_MINE,
	FrameName.LIVESTOCK_FARM,
	FrameName.UNIVERSITY,
	FrameName.ADVANCED_IRON_MINE,
	FrameName.HILLS_SCOUT_TOWER,
	FrameName.MOUNTAINS_SCOUT_TOWER,
	FrameName.BREWERY,
	FrameName.INN,
	FrameName.SHOEMAKER,
	FrameName.PATISSERIE,
	FrameName.GUARD_TOWER,
	FrameName.CARPENTRY_DISTRICT,
	FrameName.STONEMASONRY_DISTRICT,
	FrameName.TAX_OFFICE,
	FrameName.LARGE_HOUSES,
	FrameName.ARTISAN_SMITH,
	FrameName.WATER_SAW_MILL,
	FrameName.INDUSTRIAL_FOUNDRY,
	FrameName.ARENA,
	FrameName.MOUNTAIN_BELLOWS,
	FrameName.WATER_MILL,
	FrameName.BRICKYARD,
	FrameName.FLETCHER,
	FrameName.ARCHERY_RANGE,
	FrameName.SHALLOW_SEA_PEARL_HUNTER,
	FrameName.DEEP_SEA_PEARL_HUNTER,
	FrameName.PORT,
	FrameName.BATH_HOUSE,
	FrameName.GOLD_PROSPECTOR,
	FrameName.APIARY,
	FrameName.CANDLEMAKER,
	FrameName.SADDLER,
	FrameName.STABLES,
	FrameName.TEMPLE,
	FrameName.SHALLOW_SEA_BIG_FISHING_BOAT,
	FrameName.DEEP_SEA_BIG_FISHING_BOAT,
	FrameName.APOTHECARY,
	FrameName.HILLS_BLAST_FURNACE,
	FrameName.MOUNTAINS_BLAST_FURNACE,
	FrameName.STORAGE_OVERSEER,
	FrameName.ARMAMENTS_TRADER,
	FrameName.HILLS_LOOKOUT_TOWER,
	FrameName.MOUNTAINS_LOOKOUT_TOWER,
	FrameName.PEA_PATCH,
	FrameName.MANOR,
	FrameName.LARGE_BREWERY,
	FrameName.GREAT_WAREHOUSE,
	FrameName.APPLE_ORCHARD,
	FrameName.FORESTER_COTTAGE,

	FrameName.SILVER_MINE,
	FrameName.LIGHTHOUSE,
	FrameName.SHALLOW_SEA_ROCKS_LIGHTHOUSE,
	FrameName.COUNTRY_HOUSE,
	FrameName.PUMPKIN_FARM,
	FrameName.BIG_SHIPYARD,
	FrameName.FISHERMANS_HUT,
	FrameName.FISHING_VILLAGE,
	FrameName.SCULPTOR,
	FrameName.ROOF_TILE_FACTORY,
	FrameName.SEAWEED_FARM,
	FrameName.TURKEY_FARM,
	FrameName.MINT,
	FrameName.BANQUET,
	FrameName.MINSTRELS_PODIUM,
	FrameName.MONOLITH_CIRCLE,
	FrameName.LUCKY_CAULDRON,

	FrameName.RATIONS_SUPPLIER,
	FrameName.MILITARY_ACADEMY,
	FrameName.MILITIA,
	FrameName.SUPPLY_CART,
	FrameName.SUPPLY_CARAVAN,
	FrameName.ARCHERS,
	FrameName.LIGHT_CAVALRY,
	FrameName.RANGERS,
	FrameName.COMMAND_POST,
	FrameName.MILITARY_SHIPYARD,
	FrameName.SUPPLY_BOAT,
	FrameName.PATROL_BOAT,
	FrameName.FIRE_GALLEY,

	FrameName.DARKWOOD_LUMBER_MILL,
	FrameName.TOYMAKERS_WORKSHOP,
	FrameName.RABBIT_FARM,
	FrameName.RAFT,
	FrameName.BOTTLETRAP,
	FrameName.FORTRESS,
	FrameName.FIRE_FESTIVAL_PYRE,
	FrameName.ENKINDLED_HOUSEHOLD,
	FrameName.BOUNTIFUL_MARKETPLACE,
	FrameName.SOLSTICE_WINDMILL,
	FrameName.HUNTING_CAMP,
	FrameName.HIGHLAND_HUNTER,
	FrameName.SHEPHERDS_LODGE,
	FrameName.HAUNTED_MANSION,
	FrameName.CORSAIR_SHIP,
]);

export const tilerepoChristmasEventBuildingsFrameNames = new Set<FrameName>([
	FrameName.DARKWOOD_LUMBER_MILL,
	FrameName.TOYMAKERS_WORKSHOP,
]);

export const tilerepoEasterEventBuildingsFrameNames = new Set<FrameName>([
	FrameName.RABBIT_FARM,
]);

export const tilerepoFishingEventBuildingsFrameNames = new Set<FrameName>([
	FrameName.RAFT,
	FrameName.BOTTLETRAP,
	FrameName.FORTRESS,
]);

export const tilerepoFirefestEventBuildingsFrameNames = new Set<FrameName>([
	FrameName.FIRE_FESTIVAL_PYRE,
	FrameName.ENKINDLED_HOUSEHOLD,
]);

export const tilerepoSolarFairEventBuildingsFrameNames = new Set<FrameName>([
	FrameName.BOUNTIFUL_MARKETPLACE,
	FrameName.SOLSTICE_WINDMILL,
]);

export const tilerepoHuntingEventBuildingsFrameNames = new Set<FrameName>([
	FrameName.HUNTING_CAMP,
	FrameName.HIGHLAND_HUNTER,
	FrameName.SHEPHERDS_LODGE,
]);

export const tilerepoHalloweenEventBuildingsFrameNames = new Set<FrameName>([
	FrameName.HAUNTED_MANSION,
]);

export const tilerepoPiratesEventBuildingsFrameNames = new Set<FrameName>([
	FrameName.CORSAIR_SHIP,
]);

export const tilerepoEventBuildingsFrameNames = new Set<FrameName>([
	...tilerepoChristmasEventBuildingsFrameNames,
	...tilerepoEasterEventBuildingsFrameNames,
	...tilerepoFishingEventBuildingsFrameNames,
	...tilerepoFirefestEventBuildingsFrameNames,
	...tilerepoSolarFairEventBuildingsFrameNames,
	...tilerepoHuntingEventBuildingsFrameNames,
	...tilerepoHalloweenEventBuildingsFrameNames,
	...tilerepoPiratesEventBuildingsFrameNames,
]);

export const tilerepoRemovableEventBuildingTypes = new Map<FrameName, string>([
	[FrameName.DARKWOOD_LUMBER_MILL, "christmas"],
	[FrameName.RAFT, "fishing"],
	[FrameName.BOTTLETRAP, "fishing"],
	[FrameName.FIRE_FESTIVAL_PYRE, "firefest"],
	[FrameName.BOUNTIFUL_MARKETPLACE, "solarfair"],
	[FrameName.HUNTING_CAMP, "hunting"],
	[FrameName.HIGHLAND_HUNTER, "hunting"],
]);

export const tilerepoRemovableEventBuildingsFrameNames = new Set<FrameName>(
	tilerepoRemovableEventBuildingTypes.keys(),
);
export const tilerepoPurchaseableEventBuildings = new Set<FrameName>([
	FrameName.FIRE_FESTIVAL_PYRE,
	FrameName.BOUNTIFUL_MARKETPLACE,
]);

export const tilerepoPurchasableBuildingsTupleArrays = [
	["firefest", FrameName.FIRE_FESTIVAL_PYRE],
	["solarfair", FrameName.BOUNTIFUL_MARKETPLACE],
];

// TODO: suffix FrameNames
export const tilerepoPremiumGemsBuildings = new Set<FrameName>([
	...tilerepoEventBuildingsFrameNames,
	FrameName.PREMIUM_GOLD_MINE,
	FrameName.INDUSTRIAL_LUMBER_MILL,
	FrameName.OXEN_STABLE,
	FrameName.UNIVERSAL_WAREHOUSE,
	FrameName.LARGE_STONE_QUARRY,
	FrameName.LARGE_CLAY_PIT,
	FrameName.ADVANCED_IRON_MINE,
	FrameName.PATISSERIE,
	FrameName.CARPENTRY_DISTRICT,
	FrameName.STONEMASONRY_DISTRICT,
	FrameName.TAX_OFFICE,
	FrameName.INDUSTRIAL_FOUNDRY,
	FrameName.BRICKYARD,
]);

// TODO: suffix FrameNames
export const tilerepoPremiumBuildings = new Set<FrameName>([
	...tilerepoPremiumGemsBuildings,
	FrameName.SILVER_MINE,
	FrameName.LIGHTHOUSE,
	FrameName.SHALLOW_SEA_ROCKS_LIGHTHOUSE,
	FrameName.COUNTRY_HOUSE,
	FrameName.PUMPKIN_FARM,
	FrameName.BIG_SHIPYARD,
	FrameName.FISHERMANS_HUT,
	FrameName.FISHING_VILLAGE,
	FrameName.SCULPTOR,
	FrameName.ROOF_TILE_FACTORY,
	FrameName.SEAWEED_FARM,
	FrameName.TURKEY_FARM,
	FrameName.MINT,
	FrameName.BATH_HOUSE,
	FrameName.TEMPLE,
	FrameName.BANQUET,
	FrameName.MINSTRELS_PODIUM,
	FrameName.MONOLITH_CIRCLE,
	FrameName.LUCKY_CAULDRON,
	FrameName.HILLS_BLAST_FURNACE,
	FrameName.MOUNTAINS_BLAST_FURNACE,
	FrameName.STORAGE_OVERSEER,
	FrameName.ARMAMENTS_TRADER,
	FrameName.HILLS_LOOKOUT_TOWER,
	FrameName.MOUNTAINS_LOOKOUT_TOWER,
	FrameName.PEA_PATCH,
	FrameName.MANOR,
	FrameName.LARGE_BREWERY,
	FrameName.GREAT_WAREHOUSE,
	FrameName.APPLE_ORCHARD,
	FrameName.FORESTER_COTTAGE,
	FrameName.MILITARY_ACADEMY,
]);

export const tilerepoPremiumUnits = new Set<FrameName>([
	FrameName.COMMAND_POST,
	FrameName.RANGERS,
	FrameName.SUPPLY_CARAVAN,
]);

export const tilerepoNonSellableFrameNames = new Set<FrameName>([
	...tilerepoPremiumBuildings,
	...tilerepoFishingBoatsFrameNames,
	...tilerepoBigFishingBoatsFrameNames,
	...tilerepoFishTrapsFrameNames,
]);

export const tilerepoSettlementBuildingsFrameNames = new Set<FrameName>([
	FrameName.SMALL_HOUSES,
	FrameName.BAKERY,
	FrameName.TOLL_HOUSE,
	FrameName.BLACKSMITH,
	FrameName.MARKET,
	FrameName.TOOLMAKER,
	FrameName.ARMORY,
	FrameName.BARRACKS,
	FrameName.HEALERS_HUT,
	FrameName.TAILORS_WORKSHOP,
	FrameName.MEDIUM_HOUSES,
	FrameName.UNIVERSITY,
	FrameName.INN,
	FrameName.SHOEMAKER,
	FrameName.PATISSERIE,
	FrameName.GUARD_TOWER,
	FrameName.CARPENTRY_DISTRICT,
	FrameName.STONEMASONRY_DISTRICT,
	FrameName.TAX_OFFICE,
	FrameName.LARGE_HOUSES,
	FrameName.ARTISAN_SMITH,
	FrameName.SCULPTOR,
	FrameName.ARENA,
	FrameName.FLETCHER,
	FrameName.ARCHERY_RANGE,
	FrameName.BATH_HOUSE,
	FrameName.SADDLER,
	FrameName.STABLES,
	FrameName.TEMPLE,
	FrameName.APOTHECARY,
	FrameName.ARMAMENTS_TRADER,
	FrameName.RATIONS_SUPPLIER,
	FrameName.ENKINDLED_HOUSEHOLD,
]);

export const tilerepoSettlementProductionBuildingsFrameNames =
	new Set<FrameName>([
		// FrameName.SMALL_HOUSES,
		FrameName.BAKERY,
		// FrameName.TOLL_HOUSE,
		FrameName.BLACKSMITH,
		FrameName.MARKET,
		FrameName.TOOLMAKER,
		FrameName.ARMORY,
		FrameName.BARRACKS,
		// FrameName.HEALERS_HUT,
		FrameName.TAILORS_WORKSHOP,
		// FrameName.MEDIUM_HOUSES,
		FrameName.UNIVERSITY,
		FrameName.INN,
		FrameName.SHOEMAKER,
		FrameName.PATISSERIE,
		// FrameName.GUARD_TOWER,
		FrameName.CARPENTRY_DISTRICT,
		FrameName.STONEMASONRY_DISTRICT,
		FrameName.TAX_OFFICE,
		// FrameName.LARGE_HOUSES,
		FrameName.ARTISAN_SMITH,
		FrameName.SCULPTOR,
		FrameName.ARENA,
		FrameName.FLETCHER,
		FrameName.ARCHERY_RANGE,
		FrameName.BATH_HOUSE,
		FrameName.TEMPLE,
		FrameName.ENKINDLED_HOUSEHOLD,
	]);

export const tilerepoPalisades1FrameNames = new Set<FrameName>([
	FrameName.PALISADE9_LEVEL1,
	FrameName.PALISADE1_LEVEL1,
	FrameName.PALISADE3_LEVEL1,

	FrameName.PALISADE9_LEVEL2,
	FrameName.PALISADE1_LEVEL2,
	FrameName.PALISADE3_LEVEL2,

	FrameName.PALISADE9_LEVEL3,
	FrameName.PALISADE1_LEVEL3,
	FrameName.PALISADE3_LEVEL3,

	FrameName.PALISADE9_LEVEL4,
	FrameName.PALISADE1_LEVEL4,
	FrameName.PALISADE3_LEVEL4,

	FrameName.PALISADE9_LEVEL5,
	FrameName.PALISADE1_LEVEL5,
	FrameName.PALISADE3_LEVEL5,
]);

export const tilerepoPalisades3FrameNames = new Set<FrameName>([
	FrameName.PALISADE8_LEVEL1,
	FrameName.PALISADE2_LEVEL1,
	FrameName.PALISADE12_LEVEL1,
	FrameName.PALISADE4_LEVEL1,
	FrameName.PALISADE6_LEVEL1,

	FrameName.PALISADE8_LEVEL2,
	FrameName.PALISADE2_LEVEL2,
	FrameName.PALISADE12_LEVEL2,
	FrameName.PALISADE4_LEVEL2,
	FrameName.PALISADE6_LEVEL2,

	FrameName.PALISADE8_LEVEL3,
	FrameName.PALISADE2_LEVEL3,
	FrameName.PALISADE12_LEVEL3,
	FrameName.PALISADE4_LEVEL3,
	FrameName.PALISADE6_LEVEL3,

	FrameName.PALISADE8_LEVEL4,
	FrameName.PALISADE2_LEVEL4,
	FrameName.PALISADE12_LEVEL4,
	FrameName.PALISADE4_LEVEL4,
	FrameName.PALISADE6_LEVEL4,

	FrameName.PALISADE8_LEVEL5,
	FrameName.PALISADE2_LEVEL5,
	FrameName.PALISADE12_LEVEL5,
	FrameName.PALISADE4_LEVEL5,
	FrameName.PALISADE6_LEVEL5,
]);

export const tilerepoBanditsFrameNames = new Set<FrameName>([
	FrameName.BANDIT_CAMP_SMALL,
	FrameName.BANDIT_CAMP_MEDIUM,
	FrameName.BANDIT_CAMP_LARGE,
]);

export const tilerepoPiratesFrameNames = new Set<FrameName>([
	FrameName.DEEP_SEA_SMALL_PIRATES,
	FrameName.DEEP_SEA_MEDIUM_PIRATES,
	FrameName.SHALLOW_SEA_SMALL_PIRATES,
	FrameName.SHALLOW_SEA_MEDIUM_PIRATES,
]);

export const tilerepoMercenariesFrameNames = new Set<FrameName>([
	FrameName.MERCENARY_CAMP,
	FrameName.MERCENARY_SHIP,
]);

export const tilerepoFightableMainEnemiesFrameNames = new Set<FrameName>([
	FrameName.CAPTAIN_ENEMY,
	FrameName.CHIEFTAIN_ENEMY,
	FrameName.SHALLOW_SEA_RAIDERS_FLAGSHIP,
]);

export const tilerepoFightableEnemiesFrameNames = new Set<FrameName>([
	...tilerepoFightableMainEnemiesFrameNames,
	FrameName.WARRIORS_ENEMY,
	FrameName.BARRICADE_ENEMY,
	FrameName.SHALLOW_SEA_RAIDERS_SKIFF,
	FrameName.SHALLOW_SEA_RAIDERS_GALLEY,
]);

export const tilerepoFriendlySupplyUnitsFrameNames = new Set<FrameName>([
	FrameName.SUPPLY_CART,
	FrameName.SUPPLY_CARAVAN,
	FrameName.COMMAND_POST,
	FrameName.SUPPLY_BOAT,
]);

export const tilerepoSpecialUnitsFrameNames = new Set<FrameName>([
	FrameName.COMMAND_POST,
]);

export const tilerepoFriendlyMilitaryUnitsFrameNames = new Set<FrameName>([
	FrameName.MILITIA,
	FrameName.ARCHERS,
	FrameName.LIGHT_CAVALRY,
	FrameName.RANGERS,
	FrameName.PATROL_BOAT,
	FrameName.FIRE_GALLEY,
]);

export const tilerepoFriendlyUnitsFrameNames = new Set<FrameName>([
	...tilerepoFriendlySupplyUnitsFrameNames,
	...tilerepoFriendlyMilitaryUnitsFrameNames,
]);

export const tilerepoAllSiegeSystemUnitsFramenames = new Set<FrameName>([
	...tilerepoFriendlyUnitsFrameNames,
	...tilerepoFightableEnemiesFrameNames,
]);

export const tilerepoRoadsFrameNames = new Set<FrameName>([
	FrameName.DIRT_ROAD_TUTORIAL,
	FrameName.DIRT_ROAD,
	FrameName.DIRT_ROAD_1,
	FrameName.DIRT_ROAD_2,
	FrameName.DIRT_ROAD_3,
	FrameName.DIRT_ROAD_4,
	FrameName.DIRT_ROAD_5,
	FrameName.DIRT_ROAD_6,
	FrameName.DIRT_ROAD_7,
	FrameName.DIRT_ROAD_8,
	FrameName.DIRT_ROAD_9,
	FrameName.DIRT_ROAD_10,
	FrameName.DIRT_ROAD_11,
	FrameName.GRAVEL_ROAD,
	FrameName.GRAVEL_ROAD_1,
	FrameName.GRAVEL_ROAD_2,
	FrameName.GRAVEL_ROAD_3,
	FrameName.GRAVEL_ROAD_4,
	FrameName.GRAVEL_ROAD_5,
	FrameName.GRAVEL_ROAD_6,
	FrameName.GRAVEL_ROAD_7,
	FrameName.GRAVEL_ROAD_8,
	FrameName.GRAVEL_ROAD_9,
	FrameName.GRAVEL_ROAD_10,
	FrameName.GRAVEL_ROAD_11,
	FrameName.COBBLED_ROAD,
	FrameName.COBBLED_ROAD_1,
	FrameName.COBBLED_ROAD_2,
	FrameName.COBBLED_ROAD_3,
	FrameName.COBBLED_ROAD_4,
	FrameName.COBBLED_ROAD_5,
	FrameName.COBBLED_ROAD_6,
	FrameName.COBBLED_ROAD_7,
	FrameName.COBBLED_ROAD_8,
	FrameName.COBBLED_ROAD_9,
	FrameName.COBBLED_ROAD_10,
	FrameName.COBBLED_ROAD_11,
	FrameName.FORD_CROSSING,
	FrameName.FORD_CROSSING_1,
	FrameName.FORD_CROSSING_2,
	FrameName.WOODEN_BRIDGE,
	FrameName.WOODEN_BRIDGE_1,
	FrameName.WOODEN_BRIDGE_2,
	FrameName.STONE_BRIDGE,
	FrameName.STONE_BRIDGE_1,
	FrameName.STONE_BRIDGE_2,
	FrameName.MOUNTAIN_ROAD,
	FrameName.HILLY_ROAD,
]);

export const tilerepoDirtRoadsFrameNames = new Set<FrameName>([
	FrameName.DIRT_ROAD,
	FrameName.DIRT_ROAD_1,
	FrameName.DIRT_ROAD_2,
	FrameName.DIRT_ROAD_3,
	FrameName.DIRT_ROAD_4,
	FrameName.DIRT_ROAD_5,
	FrameName.DIRT_ROAD_6,
	FrameName.DIRT_ROAD_7,
	FrameName.DIRT_ROAD_8,
	FrameName.DIRT_ROAD_9,
	FrameName.DIRT_ROAD_10,
	FrameName.DIRT_ROAD_11,
]);

export const tilerepoGravelRoadsFrameNames = new Set<FrameName>([
	FrameName.GRAVEL_ROAD,
	FrameName.GRAVEL_ROAD_1,
	FrameName.GRAVEL_ROAD_2,
	FrameName.GRAVEL_ROAD_3,
	FrameName.GRAVEL_ROAD_4,
	FrameName.GRAVEL_ROAD_5,
	FrameName.GRAVEL_ROAD_6,
	FrameName.GRAVEL_ROAD_7,
	FrameName.GRAVEL_ROAD_8,
	FrameName.GRAVEL_ROAD_9,
	FrameName.GRAVEL_ROAD_10,
	FrameName.GRAVEL_ROAD_11,
]);

export const tileRepoMediumHousesFrameNames = new Set<FrameName>([
	FrameName.MEDIUM_HOUSES,
]);

export const tileRepoMarketplaceFrameNames = new Set<FrameName>([
	FrameName.MARKET,
]);

export const tileRepoHealersHutFrameNames = new Set<FrameName>([
	FrameName.HEALERS_HUT,
]);

export const tileRepoUniversityFrameNames = new Set<FrameName>([
	FrameName.UNIVERSITY,
]);

export const tileRepoArmoryFrameNames = new Set<FrameName>([FrameName.ARMORY]);

export const tileRepoScoutTowerFrameNames = new Set<FrameName>([
	FrameName.HILLS_SCOUT_TOWER,
	FrameName.MOUNTAINS_SCOUT_TOWER,
]);

export const tileRepoGuardTowerFrameNames = new Set<FrameName>([
	FrameName.GUARD_TOWER,
]);

export const tileRepoArenaFrameNames = new Set<FrameName>([FrameName.ARENA]);

export const tilerepoCobbledRoadsFrameNames = new Set<FrameName>([
	FrameName.COBBLED_ROAD,
	FrameName.COBBLED_ROAD_1,
	FrameName.COBBLED_ROAD_2,
	FrameName.COBBLED_ROAD_3,
	FrameName.COBBLED_ROAD_4,
	FrameName.COBBLED_ROAD_5,
	FrameName.COBBLED_ROAD_6,
	FrameName.COBBLED_ROAD_7,
	FrameName.COBBLED_ROAD_8,
	FrameName.COBBLED_ROAD_9,
	FrameName.COBBLED_ROAD_10,
	FrameName.COBBLED_ROAD_11,
]);

export const tilerepoFordCrossingRoadsFrameNames = new Set<FrameName>([
	FrameName.FORD_CROSSING,
	FrameName.FORD_CROSSING_1,
	FrameName.FORD_CROSSING_2,
]);

export const tilerepoWoodenBridgeRoadsFrameNames = new Set<FrameName>([
	FrameName.WOODEN_BRIDGE,
	FrameName.WOODEN_BRIDGE_1,
	FrameName.WOODEN_BRIDGE_2,
]);

export const tilerepoStoneBridgeRoadsFrameNames = new Set<FrameName>([
	FrameName.STONE_BRIDGE,
	FrameName.STONE_BRIDGE_1,
	FrameName.STONE_BRIDGE_2,
]);

export const tilerepoBridgeRoadsFrameNames = new Set<FrameName>([
	...tilerepoFordCrossingRoadsFrameNames,
	...tilerepoWoodenBridgeRoadsFrameNames,
	...tilerepoStoneBridgeRoadsFrameNames,
]);

export const tilerepoTunnelRoadsFrameNames = new Set<FrameName>([
	FrameName.MOUNTAIN_ROAD,
	FrameName.HILLY_ROAD,
]);

export const tilerepoSalvageableFrameNames = new Set<FrameName>([
	FrameName.DEPLETED_FIELD,
	FrameName.ABANDONED_HUT,
	FrameName.BURNED_HOUSE,
	FrameName.OLD_BATTLEFIELD,
	FrameName.GRASSLAND_CASTLE_RUINS,
	FrameName.HILLS_CASTLE_RUINS,
	FrameName.MERCENARY_CAMP,
	FrameName.MERCHANT_SHIP,
	FrameName.SHALLOW_SEA_SHIPWRECK,
	FrameName.SHALLOW_SEA_ROCKS_SHIPWRECK,
	FrameName.MERCENARY_SHIP,
	FrameName.TRAVELLING_MERCHANT,
	FrameName.WOLFS_DEN,
	FrameName.BEARS_DEN,
	FrameName.FLOTSAM_JETSAM,
	FrameName.DAMAGED_MILL,
	FrameName.COLLAPSED_MINE,
	FrameName.HORNETS_NEST,
]);

export const tilerepoGoldMinesFrameNames = new Set<FrameName>([
	FrameName.GOLD_MINE,
	FrameName.PREMIUM_GOLD_MINE,
]);

export const tilerepoGemsMinesFrameNames = new Set<FrameName>([
	FrameName.GEMS_MINE,
]);

export enum RequirementType {
	LEVEL,
	POPULATION, // TODO: Toto ma byt hodnota potrebna na stavbu, nie podmienka...
}

export const tilerepoPoiFrameNames = new Set<FrameName>([
	// Kubo 3
	FrameName.PARTLY_DEMOLISHED_INN1,
	FrameName.HILL_GALLOWS1,
	FrameName.CAMP_SIEGE1,
	FrameName.CAMP_SIEGE2,
	FrameName.CAMP_SIEGE3,
	FrameName.CAMP_SIEGE4,
	FrameName.MONASTERY_ABANDONED1,
	FrameName.MONASTERY_ABANDONED2,
	FrameName.MONASTERY_ABANDONED3,
	FrameName.MONASTERY_ABANDONED4,
	FrameName.FOREST_WHISPERING1,
	FrameName.FOREST_WHISPERING2,
	FrameName.FOREST_WHISPERING3,
	FrameName.FOREST_WHISPERING4,
	FrameName.FOREST_WHISPERING5,
	FrameName.FOREST_WHISPERING6,
	FrameName.FOREST_WHISPERING7,
	FrameName.FOREST_WHISPERING8,
	FrameName.FOREST_WHISPERING9,
	FrameName.WATERFALL1,
	FrameName.WATERFALL2,
	FrameName.SPRING_SACRED1,
	FrameName.WATCHPOST_BURNED1,
	FrameName.TREE_ANCIENT1,
	FrameName.CARAVAN_RUINS1,
	FrameName.CARAVAN_RUINS2,
	FrameName.CRYPT_NOBLE1,
	FrameName.CRYPT_NOBLE2,
	FrameName.STORAGE_ABANDONED1,
	FrameName.STORAGE_ABANDONED2,
	FrameName.CAVE_SHADOWS1,
	FrameName.SUNDIAL_FORGOTTEN1,
	FrameName.ALCHEMIST_ABANDONED1,
	FrameName.ALCHEMIST_ABANDONED2,
	FrameName.ALCHEMIST_ABANDONED3,
	FrameName.ALCHEMIST_ABANDONED4,
	FrameName.FORTRESS_SUNKEN1,
	FrameName.FORTRESS_SUNKEN2,
	FrameName.FORTRESS_SUNKEN3,
	FrameName.FORTRESS_SUNKEN4,
	FrameName.QUARRY_FLOODED1,
	FrameName.QUARRY_FLOODED2,
	FrameName.QUARRY_FLOODED3,
	FrameName.QUARRY_FLOODED4,
	FrameName.MONUMENT_MEGALITHIC1,
	FrameName.MONUMENT_MEGALITHIC2,
	FrameName.MONUMENT_MEGALITHIC3,
	FrameName.MONUMENT_MEGALITHIC4,
	FrameName.WHIRLPOOL1,
	FrameName.WHIRLPOOL2,
	FrameName.WHIRLPOOL3,
	FrameName.WHIRLPOOL4,
	FrameName.CASTAWAY_ISLAND1,
	FrameName.OUTPOST_SEA1,
	FrameName.OUTPOST_SEA2,
	FrameName.OUTPOST_SEA3,
	FrameName.OUTPOST_SEA4,
	FrameName.KEEP_DESERTED1,
	FrameName.KEEP_DESERTED2,
	FrameName.KEEP_DESERTED3,
	FrameName.KEEP_DESERTED4,
	FrameName.MOBY_DICK1,
	FrameName.MOBY_DICK2,
	FrameName.MOBY_DICK3,
	FrameName.MOBY_DICK4,
	FrameName.BIG_MUSHROOM1,
	FrameName.BIG_MUSHROOM2,
	FrameName.BIG_MUSHROOM3,
	FrameName.BIG_MUSHROOM4,
	FrameName.ASSASINS_HIDEOUT1,
	FrameName.ASSASINS_HIDEOUT2,
	FrameName.ASSASINS_HIDEOUT3,
	FrameName.ASSASINS_HIDEOUT4,
	FrameName.PIRATES_HIDEOUT1,
	FrameName.PIRATES_HIDEOUT2,
	FrameName.PIRATES_HIDEOUT3,
	FrameName.PIRATES_HIDEOUT4,
	FrameName.PIRATES_HIDEOUT5,
	FrameName.PIRATES_HIDEOUT6,
	FrameName.PIRATES_HIDEOUT7,
	FrameName.PIRATES_HIDEOUT8,
	FrameName.PIRATES_HIDEOUT9,
	FrameName.ASTRONOMER_HIDEOUT1,
	FrameName.ASTRONOMER_HIDEOUT2,
	FrameName.ASTRONOMER_HIDEOUT3,
	FrameName.ASTRONOMER_HIDEOUT4,
	FrameName.MOUNTAIN_LAKE1,
	FrameName.MOUNTAIN_LAKE2,
	FrameName.MOUNTAIN_LAKE3,
	FrameName.MOUNTAIN_LAKE4,
	FrameName.ATOL1,
	FrameName.ATOL2,
	FrameName.ATOL3,
	FrameName.ATOL4,
	FrameName.ATOL5,
	FrameName.ATOL6,
	FrameName.ATOL7,
	FrameName.ATOL8,
	FrameName.ATOL9,
	FrameName.BEAR_SKELETON1,
	FrameName.CRATER1,
	FrameName.CRATER2,
	FrameName.CRATER3,
	FrameName.CRATER4,
	FrameName.PLAGUED_FOREST1,
	FrameName.PLAGUED_FOREST2,
	FrameName.PLAGUED_FOREST3,
	FrameName.PLAGUED_FOREST4,
	FrameName.MENHIR1,
	FrameName.MENHIR2,
	FrameName.FALCONERS_TOWER1,
	FrameName.FALCONERS_TOWER2,
	FrameName.TERRACE_GARDENS1,
	FrameName.TERRACE_GARDENS2,
	FrameName.TERRACE_GARDENS3,
	FrameName.TERRACE_GARDENS4,
	FrameName.TERRACE_GARDENS5,
	FrameName.TERRACE_GARDENS6,
	FrameName.TERRACE_GARDENS7,
	FrameName.TERRACE_GARDENS8,
	FrameName.TERRACE_GARDENS9,
	FrameName.KRAKEN1,
	FrameName.KRAKEN2,
	FrameName.KRAKEN3,
	FrameName.KRAKEN4,
	FrameName.WITCH_LAKE1,
	FrameName.GEYSER1,
	FrameName.GEYSER2,
	FrameName.GEYSER3,
	FrameName.GEYSER4,
]);

export const tilerepoBeachesFrameNames = new Set<FrameName>([
	FrameName.BEACH1,
	FrameName.BEACH2,
	FrameName.BEACH4,
	FrameName.BEACH5,
	FrameName.BEACH8,
	FrameName.BEACH10,
	FrameName.BEACH12,
	FrameName.BEACH16,
	FrameName.BEACH17,
	FrameName.BEACH18,
	FrameName.BEACH24,
	FrameName.BEACH26,
	FrameName.BEACH32,
	FrameName.BEACH33,
	FrameName.BEACH34,
	FrameName.BEACH36,
	FrameName.BEACH37,
	FrameName.BEACH48,
	FrameName.BEACH49,
	FrameName.BEACH50,
	FrameName.BEACH64,
	FrameName.BEACH65,
	FrameName.BEACH66,
	FrameName.BEACH68,
	FrameName.BEACH69,
	FrameName.BEACH72,
	FrameName.BEACH74,
	FrameName.BEACH76,
	FrameName.BEACH80,
	FrameName.BEACH81,
	FrameName.BEACH82,
	FrameName.BEACH88,
	FrameName.BEACH90,
	FrameName.BEACH128,
	FrameName.BEACH129,
	FrameName.BEACH130,
	FrameName.BEACH132,
	FrameName.BEACH133,
	FrameName.BEACH136,
	FrameName.BEACH138,
	FrameName.BEACH140,
	FrameName.BEACH160,
	FrameName.BEACH161,
	FrameName.BEACH162,
	FrameName.BEACH164,
	FrameName.BEACH165,
]);

export const tilerepoPOIs1FrameNames = new Set<FrameName>([
	FrameName.PARTLY_DEMOLISHED_INN1,
	FrameName.HILL_GALLOWS1,
	FrameName.CAMP_SIEGE1,
	FrameName.MONASTERY_ABANDONED1,
	FrameName.FOREST_WHISPERING1,
	FrameName.WATERFALL1,
	FrameName.SPRING_SACRED1,
	FrameName.WATCHPOST_BURNED1,
	FrameName.TREE_ANCIENT1,
	FrameName.CARAVAN_RUINS1,
	FrameName.CRYPT_NOBLE1,
	FrameName.STORAGE_ABANDONED1,
	FrameName.CAVE_SHADOWS1,
	FrameName.SUNDIAL_FORGOTTEN1,
	FrameName.ALCHEMIST_ABANDONED1,
	FrameName.FORTRESS_SUNKEN1,
	FrameName.QUARRY_FLOODED1,
	FrameName.MONUMENT_MEGALITHIC1,
	FrameName.WHIRLPOOL1,
	FrameName.CASTAWAY_ISLAND1,
	FrameName.OUTPOST_SEA1,
	FrameName.KEEP_DESERTED1,
	FrameName.MOBY_DICK1,
	FrameName.BIG_MUSHROOM1,
	FrameName.ASSASINS_HIDEOUT1,
	FrameName.PIRATES_HIDEOUT1,
	FrameName.ASTRONOMER_HIDEOUT1,
	FrameName.MOUNTAIN_LAKE1,
	FrameName.ATOL1,
	FrameName.BEAR_SKELETON1,
	FrameName.CRATER1,
	FrameName.PLAGUED_FOREST1,
	FrameName.MENHIR1,
	FrameName.FALCONERS_TOWER1,
	FrameName.TERRACE_GARDENS1,
	FrameName.KRAKEN1,
	FrameName.WITCH_LAKE1,
	FrameName.GEYSER1,
]);

export const tilerepoQuickToolFrameNames = new Set<FrameName>([
	FrameName.NOT_SET,
	...tilerepoRoadsFrameNames,
	...tilerepoBuildingsFrameNames,
	...tilerepoGrasslandFrameNames,
	...tilerepoForestFrameNames,
]);

export const tilerepoShipyardFrameNames = new Set<FrameName>([
	FrameName.SHIPYARD,
	FrameName.BIG_SHIPYARD,
]);

export const tilerepoOnlyOneBuildingPerCastleFrameNames = new Set<FrameName>([
	FrameName.BAKERY,
	FrameName.TOLL_HOUSE,
	FrameName.BLACKSMITH,
	FrameName.MARKET,
	FrameName.TOOLMAKER,
	FrameName.ARMORY,
	FrameName.BARRACKS,
	FrameName.HEALERS_HUT,
	FrameName.TAILORS_WORKSHOP,
	FrameName.UNIVERSITY,
	FrameName.INN,
	FrameName.SHOEMAKER,
	FrameName.PATISSERIE,
	FrameName.GUARD_TOWER,
	FrameName.CARPENTRY_DISTRICT,
	FrameName.STONEMASONRY_DISTRICT,
	FrameName.SCULPTOR,
	FrameName.TAX_OFFICE,
	FrameName.ARTISAN_SMITH,
	FrameName.ARENA,
	FrameName.FLETCHER,
	FrameName.ARCHERY_RANGE,
	FrameName.BATH_HOUSE,
	FrameName.SADDLER,
	FrameName.STABLES,
	FrameName.TEMPLE,
	FrameName.APOTHECARY,
	FrameName.ARMAMENTS_TRADER,
	FrameName.RATIONS_SUPPLIER,
]);

export const tilerepoAccommodationBuildingsFrameNames = new Set<FrameName>([
	FrameName.BARRACKS,
	FrameName.HILLS_SCOUT_TOWER,
	FrameName.MOUNTAINS_SCOUT_TOWER,
	FrameName.OUTPOST,
	FrameName.ARCHERY_RANGE,
	FrameName.CORSAIR_SHIP,
]);

export const tilerepoHousesFrameNames = new Set<FrameName>([
	// FrameName.SETTLEMENT_CASTLE,
	FrameName.SMALL_HOUSES,
	FrameName.MEDIUM_HOUSES,
	FrameName.LARGE_HOUSES,
	FrameName.COUNTRY_HOUSE,
	FrameName.CARPENTRY_DISTRICT,
	FrameName.STONEMASONRY_DISTRICT,
	FrameName.ENKINDLED_HOUSEHOLD,
]);

export const tilerepoBuildingForCastleFrameNames = new Set<FrameName>([
	...tilerepoOnlyOneBuildingPerCastleFrameNames,
	...tilerepoSettlementProductionBuildingsFrameNames,
	...tilerepoHousesFrameNames,
]);

export const tilerepoGravelEntityFrameNames = new Set<FrameName>([
	...tilerepoGravelRoadsFrameNames,
	...tilerepoWoodenBridgeRoadsFrameNames,
]);

export const tilerepoCobbledEntityFrameNames = new Set<FrameName>([
	...tilerepoCobbledRoadsFrameNames,
	...tilerepoStoneBridgeRoadsFrameNames,
	...tilerepoTunnelRoadsFrameNames,
]);

export const tilerepoLandRoadsOnlyFrameNames = new Set<FrameName>([
	...tilerepoDirtRoadsFrameNames,
	...tilerepoGravelRoadsFrameNames,
	...tilerepoCobbledRoadsFrameNames,
]);

export const tilerepoRiverRoadsOnlyFrameNames = new Set<FrameName>([
	...tilerepoFordCrossingRoadsFrameNames,
	...tilerepoWoodenBridgeRoadsFrameNames,
	...tilerepoStoneBridgeRoadsFrameNames,
]);

export const tilerepoDuplicateFrameNames = new Set<FrameName>([
	FrameName.DEEP_SEA_FISHING_BOAT,
	FrameName.SHALLOW_SEA_MEDIUM_FISH_TRAP,
	FrameName.MOUNTAINS_SCOUT_TOWER,
	FrameName.MOUNTAIN_ROAD,
	FrameName.DEEP_SEA_PEARL_HUNTER,
	FrameName.DEEP_SEA_BIG_FISHING_BOAT,
]);

// TODO: toto zmenit na tilerepoRemovableEventBuildingsFrameNames
export const tilerepoEventBuildingToRemoveAfterEventEndsFrameNames =
	new Set<FrameName>([FrameName.DARKWOOD_LUMBER_MILL]);

export const tilerepoStoneQuarriesFrameNames = new Set<FrameName>([
	FrameName.STONE_QUARRY,
	FrameName.LARGE_STONE_QUARRY,
]);

export const tilerepoClayPitsFrameNames = new Set<FrameName>([
	FrameName.CLAY_PIT,
	FrameName.LARGE_CLAY_PIT,
]);

export const tilerepoIronMinesFrameNames = new Set<FrameName>([
	FrameName.IRON_MINE,
	FrameName.ADVANCED_IRON_MINE,
]);

export const tilerepoBiggerWarehouseFrameNames = new Set<FrameName>([
	FrameName.WAREHOUSE,
	FrameName.UNIVERSAL_WAREHOUSE,
]);

export const tilerepoMillsFrameNames = new Set<FrameName>([
	FrameName.MILL,
	FrameName.WATER_MILL,
]);

export const tilerepoNotStorableFrameNames = new Set<FrameName>([
	...tileRepoScoutTowerFrameNames,
	...tilerepoFarmFieldsFrameNames,
	...tilerepoPremiumUnits,
	...tilerepoFriendlyUnitsFrameNames,
]);

export const tilerepoExplorationBuildingsFrameNames = new Set<FrameName>([
	FrameName.LIGHTHOUSE,
	FrameName.SHALLOW_SEA_ROCKS_LIGHTHOUSE,
	FrameName.TEMPLE,
	FrameName.MONOLITH_CIRCLE,
	FrameName.HILLS_LOOKOUT_TOWER,
	FrameName.MOUNTAINS_LOOKOUT_TOWER,
]);

export const doubledFrameNames = new Set<FrameName>([
	...tilerepoFishingBoatsFrameNames,
	...tilerepoBigFishingBoatsFrameNames,
	...tilerepoLightHousesFrameNames,
	...tilerepoFishTrapsFrameNames,
	...tilerepoCoralReefsFrameNames,
	...tilerepoShipwrecksFrameNames,
	...tilerepoPearlHuntersFrameNames,
	...tileRepoScoutTowerFrameNames,
	...tilerepoMillsFrameNames,
	...tilerepoTunnelRoadsFrameNames,
	...tilerepoBlastFurnacesFrameNames,
	...tilerepoLookoutTowersFrameNames,
]);

export const doubledFrameNamesGroups = [
	tilerepoFishingBoatsFrameNames,
	tilerepoBigFishingBoatsFrameNames,
	tilerepoLightHousesFrameNames,
	tilerepoFishTrapsFrameNames,
	tilerepoCoralReefsFrameNames,
	tilerepoShipwrecksFrameNames,
	tilerepoPearlHuntersFrameNames,
	tileRepoScoutTowerFrameNames,
	tilerepoMillsFrameNames,
	tilerepoTunnelRoadsFrameNames,
	tilerepoBlastFurnacesFrameNames,
];

export const tilerepoHideRangeIndicatorsFrameNames = new Set<FrameName>([
	...tilerepoHousesFrameNames,
	FrameName.BARRACKS,
	FrameName.ARCHERY_RANGE,
	FrameName.STABLES,
	FrameName.ARMAMENTS_TRADER,
	FrameName.BANDIT_CAMP_SMALL,
	FrameName.BANDIT_CAMP_MEDIUM,
	FrameName.BANDIT_CAMP_LARGE,
	FrameName.SHALLOW_SEA_SMALL_PIRATES,
	FrameName.DEEP_SEA_SMALL_PIRATES,
	FrameName.SHALLOW_SEA_MEDIUM_PIRATES,
	FrameName.DEEP_SEA_MEDIUM_PIRATES,
	// FrameName.WARRIORS_ENEMY,
	// FrameName.BARRICADE_ENEMY,
	FrameName.CAPTAIN_ENEMY,
	FrameName.CHIEFTAIN_ENEMY,
	// FrameName.SHALLOW_SEA_RAIDERS_SKIFF,
	// FrameName.SHALLOW_SEA_RAIDERS_GALLEY,
	FrameName.SHALLOW_SEA_RAIDERS_FLAGSHIP,
	FrameName.BANQUET,
	// FrameName.MINSTRELS_PODIUM,
	// FrameName.MONOLITH_CIRCLE,
	FrameName.FIRE_FESTIVAL_PYRE,
]);
